{
  "schemaVersion": 2,
  "id": "create-friends",
  "stage": {
    "w": 941,
    "h": 1672
  },
  "units": "stage units; PNG slice values are source pixels; dimensions are per piece",
  "sourceRoot": "repository root",
  "reference": "art/src/create-elements-2026-10-05/NOW-create-friends.png",
  "defaultState": "friends",
  "defaultExample": "friends_default",
  "theme": {
    "id": "friends",
    "cyanFilter": "hue-rotate(200deg) saturate(1.2)"
  },
  "textContract": {
    "renderer": "Ink / KitText for live text; title and CTA lettering are separate transparent image elements.",
    "position": "x/y/w/h is the fixed lane; capCenterY is its optical centre; image ink bounds are separate measurements",
    "sizing": "Owner-selected Nunito 700 26 for all chip words, unchanged 32 labels. BRIEF-create-3 supersedes the historical A/B choice.",
    "ordinaryOverflow": "visible; existing too-small lanes are recorded, never silently resized",
    "codeMaxW": "not applicable: no room code on Create",
    "roles": {
      "label": {
        "font": "Nunito",
        "size": 32,
        "weight": 800,
        "trackingEm": 0.01,
        "lineHeight": 40
      },
      "caption": {
        "font": "Nunito",
        "size": 26,
        "weight": 500,
        "trackingEm": 0,
        "lineHeight": 33
      },
      "chip": {
        "font": "Nunito",
        "size": 26,
        "weight": 700,
        "trackingEm": 0,
        "lineHeight": 33
      },
      "action": {
        "font": "Nunito",
        "size": 56,
        "weight": 800,
        "trackingEm": 0,
        "lineHeight": 70
      },
      "hero": {
        "font": "Nunito",
        "size": 84,
        "weight": 800,
        "trackingEm": 0,
        "lineHeight": 105
      },
      "button": {
        "font": "Nunito",
        "size": 32,
        "weight": 800,
        "trackingEm": 0,
        "lineHeight": 40
      }
    }
  },
  "colors": {
    "white": "#ffffff",
    "gold": "#ffe36a",
    "disabled": "#6f7ba8",
    "sub": "#9fd8ff",
    "howto": "#ffd84a",
    "onGold": "#17120a"
  },
  "textClasses": {
    "gold": {
      "color": "#ffe36a"
    },
    "off": {
      "color": "#6f7ba8"
    },
    "on-gold": {
      "color": "#17120a"
    }
  },
  "pieces": {
    "board9.png": {
      "path": "apps/client/public/art/lobby-kit/board9.png",
      "pixelW": 640,
      "pixelH": 640,
      "alpha": true,
      "sha256": "ff3a8f9078435101fdc3c4ce5d5ecdaa17e6de5999278710861bf503700665fb",
      "reused": true,
      "slicePx": {
        "top": 128,
        "right": 128,
        "bottom": 128,
        "left": 128
      },
      "cornerKStage": 64
    },
    "row.divider.png": {
      "path": "apps/client/public/art/lobby-kit/row.divider.png",
      "pixelW": 800,
      "pixelH": 24,
      "alpha": true,
      "sha256": "2a1ea1caad9ff24d8de98d9374920456dee39b81f83bf78fbc1302f301848ba3",
      "reused": true,
      "slicePx": {
        "top": 0,
        "right": 24,
        "bottom": 0,
        "left": 24
      }
    },
    "small.button.png": {
      "path": "apps/client/public/art/lobby-kit/small.button.png",
      "pixelW": 812,
      "pixelH": 228,
      "alpha": true,
      "sha256": "c0a274c1d527673a77055107fae0cbd3149ec8fbbe9fb2128129515ba86479ed",
      "reused": true,
      "slicePx": {
        "top": 0,
        "right": 229,
        "bottom": 0,
        "left": 229
      }
    },
    "cta.plate.png": {
      "path": "apps/client/public/art/lobby-kit/cta.plate.png",
      "pixelW": 1736,
      "pixelH": 326,
      "alpha": true,
      "sha256": "ae9529479f4f35a908b8acd3f2e196be029ae229eb90d3b4dc969e7d8e7dcdde",
      "reused": true,
      "slicePx": {
        "top": 0,
        "right": 331,
        "bottom": 0,
        "left": 331
      }
    },
    "sticker.ul.png": {
      "path": "apps/client/public/art/lobby-kit/sticker.ul.png",
      "pixelW": 328,
      "pixelH": 308,
      "alpha": true,
      "sha256": "54f64ea3c8e610d9681118192d797074b5f005d3f3b570cf75d4760c1678660d",
      "reused": true
    },
    "sticker.ur.png": {
      "path": "apps/client/public/art/lobby-kit/sticker.ur.png",
      "pixelW": 396,
      "pixelH": 308,
      "alpha": true,
      "sha256": "0112673e6dbd9a38ab1c48d9a523973d6ccba02b38e3dd02cc6edd7728cd8f8e",
      "reused": true
    },
    "apps/client/public/art/ui-head/bg@2x.png": {
      "path": "apps/client/public/art/ui-head/bg@2x.png",
      "pixelW": 276,
      "pixelH": 276,
      "alpha": true,
      "sha256": "ed70ede39d5d34e59c6619b7d84082814b69058bbd929b4ce0d895185220f820",
      "reused": true
    },
    "apps/client/public/art/ui-head/icon-back@2x.png": {
      "path": "apps/client/public/art/ui-head/icon-back@2x.png",
      "pixelW": 276,
      "pixelH": 276,
      "alpha": true,
      "sha256": "026c480685d45fca3639e55537d5a3d3557f3ffb72cfbbf6e6e84354ad954694",
      "reused": true
    },
    "apps/client/public/art/ui-head/icon-sound-on@2x.png": {
      "path": "apps/client/public/art/ui-head/icon-sound-on@2x.png",
      "pixelW": 276,
      "pixelH": 276,
      "alpha": true,
      "sha256": "4cbe7e8ec9c7d9ab1dc14c1046c12fe03684e9fc1853b3514e18acbc014671ff",
      "reused": true
    },
    "apps/client/public/art/ui-head/icon-sound-off@2x.png": {
      "path": "apps/client/public/art/ui-head/icon-sound-off@2x.png",
      "pixelW": 276,
      "pixelH": 276,
      "alpha": true,
      "sha256": "25814b1deba5c0188b2840bb696bc15f34d5fbaeaf21f049790b4b13e2d0b249",
      "reused": true
    },
    "create.icon.players": {
      "path": "art/src/create-elements-2026-10-05/delivery/icon.players.png",
      "pixelW": 82,
      "pixelH": 63,
      "alpha": true,
      "sha256": "219264a5130c4ee7f2eb30d3ec64a54450f2f093eadde8913e88eff808383a7b",
      "reused": true,
      "masterPath": "art/src/create-elements-2026-10-05/pieces/icon.players@4x.png",
      "nativeMasterPath": "art/src/create-elements-2026-10-05/pieces/icon.players.master.png",
      "masterPixelW": 232,
      "masterPixelH": 180,
      "appearanceVerified": false
    },
    "create.icon.rounds": {
      "path": "art/src/create-elements-2026-10-05/delivery/icon.rounds.png",
      "pixelW": 76,
      "pixelH": 79,
      "alpha": true,
      "sha256": "187a8414eadd04e426374564632d8c7de54fb7a961d3a278c09f877e7f8de066",
      "reused": true,
      "masterPath": "art/src/create-elements-2026-10-05/pieces/icon.rounds@4x.png",
      "nativeMasterPath": "art/src/create-elements-2026-10-05/pieces/icon.rounds.master.png",
      "masterPixelW": 216,
      "masterPixelH": 224,
      "appearanceVerified": false
    },
    "create.icon.pace": {
      "path": "art/src/create-elements-2026-10-05/delivery/icon.pace.png",
      "pixelW": 58,
      "pixelH": 77,
      "alpha": true,
      "sha256": "77954f485442336a23a785b925a819e3cf72d4c60a75e3864b58a3af280c9c90",
      "reused": true,
      "masterPath": "art/src/create-elements-2026-10-05/pieces/icon.pace@4x.png",
      "nativeMasterPath": "art/src/create-elements-2026-10-05/pieces/icon.pace.master.png",
      "masterPixelW": 164,
      "masterPixelH": 220,
      "appearanceVerified": false
    },
    "create.icon.vibe": {
      "path": "art/src/create-elements-2026-10-05/delivery/icon.vibe.png",
      "pixelW": 77,
      "pixelH": 73,
      "alpha": true,
      "sha256": "84120d1f8654a0c4b7a8e754fd78da07d1e93192bb3aca5bc19ebb5b6f5b8f92",
      "reused": true,
      "masterPath": "art/src/create-elements-2026-10-05/pieces/icon.vibe@4x.png",
      "nativeMasterPath": "art/src/create-elements-2026-10-05/pieces/icon.vibe.master.png",
      "masterPixelW": 220,
      "masterPixelH": 208,
      "appearanceVerified": false
    },
    "create.icon.date": {
      "path": "art/src/create-elements-2026-10-05/delivery/icon.date.png",
      "pixelW": 93,
      "pixelH": 87,
      "alpha": true,
      "sha256": "91735ea56c9514fe121cdcd8fa371eaed8c8e01eb44d986012ba229a87d2692f",
      "reused": true,
      "masterPath": "art/src/create-elements-2026-10-05/pieces/icon.date@4x.png",
      "nativeMasterPath": "art/src/create-elements-2026-10-05/pieces/icon.date.master.png",
      "masterPixelW": 264,
      "masterPixelH": 248,
      "appearanceVerified": false
    },
    "create.howto.icon": {
      "path": "art/src/create-elements-2026-10-05/delivery/howto.icon.png",
      "pixelW": 153,
      "pixelH": 154,
      "alpha": true,
      "sha256": "af90d193dcc844c307ed758a9262648ad7a9f71d3c7089c126c84de7f9a979b6",
      "reused": true,
      "masterPath": "art/src/create-elements-2026-10-05/pieces/howto.icon@4x.png",
      "nativeMasterPath": "art/src/create-elements-2026-10-05/pieces/howto.icon.master.png",
      "masterPixelW": 436,
      "masterPixelH": 440,
      "appearanceVerified": false
    },
    "create.date.switch.off": {
      "path": "art/src/create-elements-2026-10-05/delivery/date.switch.off.png",
      "pixelW": 219,
      "pixelH": 129,
      "alpha": true,
      "sha256": "c6ddda1bb3f13b7878943916929fb4c7d91842437348d294904d13245c903ff3",
      "reused": true,
      "masterPath": "art/src/create-elements-2026-10-05/pieces/date.switch.off@4x.png",
      "nativeMasterPath": "art/src/create-elements-2026-10-05/pieces/date.switch.off.master.png",
      "masterPixelW": 624,
      "masterPixelH": 368,
      "appearanceVerified": false
    },
    "create.date.switch.on": {
      "path": "art/src/create-elements-2026-10-05/delivery/date.switch.on.png",
      "pixelW": 219,
      "pixelH": 129,
      "alpha": true,
      "sha256": "09bc900cbc044b5b6ad62c36132ddc0a3e7726f67652e5e0a74616a6ab43f40e",
      "reused": true,
      "masterPath": "art/src/create-elements-2026-10-05/pieces/date.switch.on@4x.png",
      "nativeMasterPath": "art/src/create-elements-2026-10-05/pieces/date.switch.on.master.png",
      "masterPixelW": 624,
      "masterPixelH": 368,
      "appearanceVerified": false
    },
    "create.pill.off": {
      "path": "art/src/create-elements-2026-10-05/delivery/slice/pill.off.png",
      "pixelW": 247,
      "pixelH": 140,
      "alpha": true,
      "sha256": "4e4c0d8bfeb8c1fcaabb2a0cb9f02c3979a9a723a189da8df7ebaab469d32cb2",
      "reused": true,
      "masterPath": "art/src/create-elements-2026-10-05/pieces/slice/pill.off@4x.png",
      "nativeMasterPath": "art/src/create-elements-2026-10-05/pieces/pill.off.master.png",
      "masterPixelW": 704,
      "masterPixelH": 400,
      "appearanceVerified": false,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "masterSlicePx": {
        "top": 0,
        "right": 240,
        "bottom": 0,
        "left": 240
      }
    },
    "create.pill.on": {
      "path": "art/src/create-elements-2026-10-05/delivery/slice/pill.on.png",
      "pixelW": 247,
      "pixelH": 140,
      "alpha": true,
      "sha256": "fe020c119da9e66c9acf92c0da5a3d57bab8f6a617716ee20eb5a7d6dbcdc0b3",
      "reused": true,
      "masterPath": "art/src/create-elements-2026-10-05/pieces/slice/pill.on@4x.png",
      "nativeMasterPath": "art/src/create-elements-2026-10-05/pieces/pill.on.master.png",
      "masterPixelW": 704,
      "masterPixelH": 400,
      "appearanceVerified": false,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "masterSlicePx": {
        "top": 0,
        "right": 240,
        "bottom": 0,
        "left": 240
      }
    },
    "title": {
      "path": "art/src/create-elements-2026-10-05/delivery2/title@2x.png",
      "pixelW": 1180,
      "pixelH": 248,
      "alpha": true,
      "sha256": "53f6fcc7ae2539486125590ef88e9125402f32ccb90a3d910d719674cf7e41f4",
      "masterPath": "art/src/create-elements-2026-10-05/pieces2/title@4x.png",
      "masterPixelW": 2360,
      "masterPixelH": 496,
      "releasePath": "art/src/create-elements-2026-10-05/delivery2/title.webp",
      "releasePixelW": 539,
      "releasePixelH": 113,
      "reused": true,
      "slice": "none; lettering scales uniformly",
      "futurePublicPath": "apps/client/public/art/create-kit/title@2x.png"
    },
    "cta.lettering": {
      "path": "art/src/create-elements-2026-10-05/delivery2/cta.lettering@2x.png",
      "pixelW": 1024,
      "pixelH": 216,
      "alpha": true,
      "sha256": "a003db25c7f27863e702cc4c257cdd30a6615d0abfdc87378133be8cea8b37fd",
      "masterPath": "art/src/create-elements-2026-10-05/pieces2/cta.lettering@4x.png",
      "masterPixelW": 2048,
      "masterPixelH": 432,
      "releasePath": "art/src/create-elements-2026-10-05/delivery2/cta.lettering.webp",
      "releasePixelW": 468,
      "releasePixelH": 99,
      "reused": true,
      "slice": "none; lettering scales uniformly",
      "futurePublicPath": "apps/client/public/art/create-kit/cta.lettering@2x.png"
    },
    "k18.badge": {
      "path": "apps/client/public/art/create-kit/k18.badge.png",
      "pixelW": 152,
      "pixelH": 152,
      "sha256": "6ec66aa7bcc341c134a8e839faf3be9ced5f679b1c39c1c09193a115dc5ef50a",
      "reused": true,
      "alpha": true,
      "source": "owner",
      "masterPath": "/var/www/play.saynoway.com/materials/k18-badge.png",
      "masterPixelW": 1254,
      "masterPixelH": 1254,
      "masterSha256": "575e6ade627231a2c3a1701d4d0e236a3568393745f442ca61ae0c94bd1a281d",
      "note": "the owner's own red 18 ball, delivered 6.10.2026; it replaces the reused adult-v1 in this view, resized to 2x only"
    },
    "apps/client/public/art/lobby-bg/friends.png": {
      "path": "apps/client/public/art/lobby-bg/friends.png",
      "pixelW": 941,
      "pixelH": 1672,
      "alpha": false,
      "sha256": "5f0ba22c8354bedb837806daf9269877ef3a7c29edae44504588e08bfa2c4e3b",
      "reused": true
    },
    "apps/client/public/art/room-logos/lobby-friends.png": {
      "path": "apps/client/public/art/room-logos/lobby-friends.png",
      "pixelW": 880,
      "pixelH": 500,
      "alpha": true,
      "sha256": "00944ff4a68a8ee16ccd9cd0d884e04e4095843dc2aea32cf8ca0f08cbda6f78",
      "reused": true
    },
    "apps/client/public/art/lobby-kit/slogan.friends.l.png": {
      "path": "apps/client/public/art/lobby-kit/slogan.friends.l.png",
      "pixelW": 300,
      "pixelH": 322,
      "alpha": true,
      "sha256": "e969b9a216c5484ddae704bce7ef2909cc52b36f48b9af074e0aed3c8d747719",
      "reused": true
    },
    "apps/client/public/art/lobby-kit/slogan.friends.r.png": {
      "path": "apps/client/public/art/lobby-kit/slogan.friends.r.png",
      "pixelW": 295,
      "pixelH": 322,
      "alpha": true,
      "sha256": "33d638f768c4226be646a6f239817e90ff2b479674568cd070c8f58a20c0f8ba",
      "reused": true
    },
    "apps/client/public/art/lobby-bg/date.png": {
      "path": "apps/client/public/art/lobby-bg/date.png",
      "pixelW": 941,
      "pixelH": 1672,
      "alpha": false,
      "sha256": "fe7bbf5f7f68ad52be2de726a308872fdeb1efb544e5998ae9795f03d91db854",
      "reused": true
    },
    "apps/client/public/art/room-logos/lobby-date.png": {
      "path": "apps/client/public/art/room-logos/lobby-date.png",
      "pixelW": 880,
      "pixelH": 521,
      "alpha": true,
      "sha256": "b694f0f1acceccfd6531128c0e57318b9d3d3d98180e4adef5dad33ae38debbd",
      "reused": true
    },
    "apps/client/public/art/lobby-kit/slogan.date.l.png": {
      "path": "apps/client/public/art/lobby-kit/slogan.date.l.png",
      "pixelW": 342,
      "pixelH": 281,
      "alpha": true,
      "sha256": "04ffccb13e2789eac8e479fa762c99d0b5c8b711f7a3eaef5f7b295ac7900009",
      "reused": true
    },
    "apps/client/public/art/lobby-kit/slogan.date.r.png": {
      "path": "apps/client/public/art/lobby-kit/slogan.date.r.png",
      "pixelW": 348,
      "pixelH": 309,
      "alpha": true,
      "sha256": "bc0661fbe9b009463e76d3c01993583da2c026f2b14ea6de49ceae846b74eca8",
      "reused": true
    },
    "icon.info.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.info.png",
      "pixelW": 640,
      "pixelH": 640,
      "alpha": true,
      "source": "the owner's /var/www/play.saynoway.com/icons/circle-info-solid.png (fa-solid circle-info), 23.9.2026",
      "reused": true,
      "sha256": "01566712c254793cf47ab8b4c65ffa650289a9b20c26c4a15ff8da9a1b5165e0"
    }
  },
  "elements": [
    {
      "id": "background",
      "piece": "apps/client/public/art/lobby-bg/friends.png",
      "x": 0,
      "y": 0,
      "w": 941,
      "h": 1672,
      "render": "image",
      "tint": "none",
      "z": 0
    },
    {
      "id": "logo",
      "piece": "apps/client/public/art/room-logos/lobby-friends.png",
      "x": 267,
      "y": 8,
      "w": 440,
      "h": 250,
      "render": "image",
      "tint": "none",
      "z": 20
    },
    {
      "id": "back.button",
      "piece": "apps/client/public/art/ui-head/bg@2x.png",
      "x": 16,
      "y": 9,
      "w": 120,
      "h": 120,
      "render": "image",
      "tint": "none",
      "z": 60,
      "mirrorX": false
    },
    {
      "id": "back.icon",
      "piece": "apps/client/public/art/ui-head/icon-back@2x.png",
      "x": 16,
      "y": 9,
      "w": 120,
      "h": 120,
      "render": "image",
      "tint": "none",
      "z": 61
    },
    {
      "id": "sound.button",
      "piece": "apps/client/public/art/ui-head/bg@2x.png",
      "x": 812,
      "y": 9,
      "w": 120,
      "h": 120,
      "render": "image",
      "tint": "none",
      "z": 60,
      "mirrorX": true
    },
    {
      "id": "sound.icon",
      "piece": "apps/client/public/art/ui-head/icon-sound-on@2x.png",
      "x": 812,
      "y": 9,
      "w": 120,
      "h": 120,
      "render": "image",
      "tint": "none",
      "z": 61
    },
    {
      "id": "sticker.ul",
      "piece": "apps/client/public/art/lobby-kit/slogan.friends.l.png",
      "x": 44,
      "y": 130,
      "w": 170,
      "h": 182.467,
      "render": "image",
      "tint": "none",
      "z": 12
    },
    {
      "id": "sticker.ur",
      "piece": "apps/client/public/art/lobby-kit/slogan.friends.r.png",
      "x": 739,
      "y": 127,
      "w": 170,
      "h": 185.559,
      "render": "image",
      "tint": "none",
      "z": 12
    },
    {
      "id": "form",
      "piece": "board9.png",
      "x": 60,
      "y": 428,
      "w": 824,
      "h": 1108,
      "render": "border-image",
      "tint": "none",
      "z": 20,
      "slicePx": {
        "top": 128,
        "right": 128,
        "bottom": 128,
        "left": 128
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "borderWidthStage": 64
    },
    {
      "id": "divider.players",
      "piece": "row.divider.png",
      "x": 108,
      "y": 597,
      "w": 726,
      "h": 12,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 24,
        "bottom": 0,
        "left": 24
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight"
    },
    {
      "id": "divider.rounds",
      "piece": "row.divider.png",
      "x": 108,
      "y": 757,
      "w": 726,
      "h": 12,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 24,
        "bottom": 0,
        "left": 24
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight"
    },
    {
      "id": "divider.pace",
      "piece": "row.divider.png",
      "x": 108,
      "y": 917,
      "w": 726,
      "h": 12,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 24,
        "bottom": 0,
        "left": 24
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight"
    },
    {
      "id": "divider.vibe",
      "piece": "row.divider.png",
      "x": 108,
      "y": 1075,
      "w": 726,
      "h": 12,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 24,
        "bottom": 0,
        "left": 24
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight"
    },
    {
      "id": "chip.p3",
      "piece": "create.pill.off",
      "x": 90,
      "y": 500,
      "w": 206,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 102,
        "y": 512,
        "w": 182,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.p4",
      "piece": "create.pill.off",
      "x": 274,
      "y": 500,
      "w": 206,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 286,
        "y": 512,
        "w": 182,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.p5",
      "piece": "create.pill.off",
      "x": 460,
      "y": 500,
      "w": 206,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 472,
        "y": 512,
        "w": 182,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.p6",
      "piece": "create.pill.off",
      "x": 646,
      "y": 500,
      "w": 206,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 658,
        "y": 512,
        "w": 182,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.r1",
      "piece": "create.pill.off",
      "x": 90,
      "y": 658,
      "w": 266,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 102,
        "y": 670,
        "w": 242,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.r2",
      "piece": "create.pill.off",
      "x": 338,
      "y": 658,
      "w": 268,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 350,
        "y": 670,
        "w": 244,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.r3",
      "piece": "create.pill.off",
      "x": 586,
      "y": 658,
      "w": 268,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 598,
        "y": 670,
        "w": 244,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.chill",
      "piece": "create.pill.off",
      "x": 90,
      "y": 816,
      "w": 390,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 102,
        "y": 828,
        "w": 366,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.quick",
      "piece": "create.pill.off",
      "x": 462,
      "y": 816,
      "w": 392,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 474,
        "y": 828,
        "w": 368,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.v1",
      "piece": "create.pill.off",
      "x": 90,
      "y": 976,
      "w": 205.5,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 102,
        "y": 988,
        "w": 181.5,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.v2",
      "piece": "create.pill.off",
      "x": 277.5,
      "y": 976,
      "w": 205.5,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 289.5,
        "y": 988,
        "w": 181.5,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.v3",
      "piece": "create.pill.off",
      "x": 465,
      "y": 976,
      "w": 205.5,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 477,
        "y": 988,
        "w": 181.5,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.v4",
      "piece": "create.pill.off",
      "x": 652.5,
      "y": 976,
      "w": 205.5,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 664.5,
        "y": 988,
        "w": 181.5,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.pair",
      "piece": "create.pill.off",
      "x": 338,
      "y": 500,
      "w": 268,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 350,
        "y": 512,
        "w": 244,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "howto.plate",
      "piece": "small.button.png",
      "x": 258.956,
      "y": 1552,
      "w": 423.088,
      "h": 104,
      "render": "3-slice",
      "tint": "cyan",
      "z": 20,
      "slicePx": {
        "top": 0,
        "right": 229,
        "bottom": 0,
        "left": 229
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight"
    },
    {
      "id": "cta.plate",
      "piece": "cta.plate.png",
      "x": 36,
      "y": 1724,
      "w": 868,
      "h": 144,
      "render": "3-slice",
      "tint": "none",
      "z": 20,
      "slicePx": {
        "top": 0,
        "right": 331,
        "bottom": 0,
        "left": 331
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight"
    },
    {
      "id": "icon.players",
      "piece": "create.icon.players",
      "x": 105,
      "y": 464,
      "w": 58,
      "h": 45,
      "render": "image",
      "tint": "none",
      "z": 21,
      "inkBoxStage": {
        "x": 109,
        "y": 468,
        "w": 50,
        "h": 37
      }
    },
    {
      "id": "icon.rounds",
      "piece": "create.icon.rounds",
      "x": 107,
      "y": 617,
      "w": 54,
      "h": 56,
      "render": "image",
      "tint": "none",
      "z": 21,
      "inkBoxStage": {
        "x": 111,
        "y": 621,
        "w": 46,
        "h": 48
      }
    },
    {
      "id": "icon.pace",
      "piece": "create.icon.pace",
      "x": 114,
      "y": 776,
      "w": 41,
      "h": 55,
      "render": "image",
      "tint": "none",
      "z": 21,
      "inkBoxStage": {
        "x": 118,
        "y": 780,
        "w": 33,
        "h": 47
      }
    },
    {
      "id": "icon.vibe",
      "piece": "create.icon.vibe",
      "x": 107,
      "y": 938,
      "w": 55,
      "h": 52,
      "render": "image",
      "tint": "none",
      "z": 21,
      "inkBoxStage": {
        "x": 111,
        "y": 942,
        "w": 47,
        "h": 44
      }
    },
    {
      "id": "icon.date",
      "piece": "create.icon.date",
      "x": 106,
      "y": 1422,
      "w": 66,
      "h": 62,
      "render": "image",
      "tint": "none",
      "z": 21,
      "inkBoxStage": {
        "x": 110,
        "y": 1426,
        "w": 58,
        "h": 54
      }
    },
    {
      "id": "howto.icon",
      "piece": "icon.info.png",
      "x": 322.27200000000005,
      "y": 1578,
      "w": 50,
      "h": 50,
      "render": "image",
      "tint": "none",
      "z": 21,
      "sourceFilter": "brightness(0) invert(1)"
    },
    {
      "id": "date.switch",
      "piece": "create.date.switch.off",
      "x": 692,
      "y": 1422,
      "w": 156,
      "h": 92,
      "render": "image",
      "tint": "none",
      "z": 21,
      "inkBoxStage": {
        "x": 710,
        "y": 1438,
        "w": 123,
        "h": 60
      },
      "controlBoxStage": {
        "x": 696,
        "y": 1426,
        "w": 148,
        "h": 84
      }
    },
    {
      "id": "title",
      "piece": "title",
      "x": 180,
      "y": 296,
      "w": 590,
      "h": 124,
      "render": "image",
      "tint": "none",
      "filter": "none",
      "z": 46,
      "pointerEvents": "none"
    },
    {
      "id": "cta.lettering",
      "piece": "cta.lettering",
      "x": 214,
      "y": 1742,
      "w": 512,
      "h": 108,
      "render": "image",
      "tint": "none",
      "filter": "none",
      "z": 46,
      "pointerEvents": "none"
    },
    {
      "id": "k18.badge.bolder",
      "parent": "chip.v2",
      "x": 417,
      "y": 947,
      "w": 61,
      "h": 61,
      "piece": "k18.badge",
      "render": "image",
      "tint": "none",
      "filter": "none",
      "opacity": 1,
      "z": 48,
      "pointerEvents": "none",
      "anchor": {
        "parent": "chip.v2",
        "point": "artwork top right",
        "dx": -66,
        "dy": -29,
        "offsetTarget": "badge canvas top left"
      },
      "meaning": "18+ content notice; same in all selection and availability states"
    },
    {
      "id": "k18.badge.naughty",
      "parent": "chip.v4",
      "x": 792,
      "y": 947,
      "w": 61,
      "h": 61,
      "piece": "k18.badge",
      "render": "image",
      "tint": "none",
      "filter": "none",
      "opacity": 1,
      "z": 48,
      "pointerEvents": "none",
      "anchor": {
        "parent": "chip.v4",
        "point": "artwork top right",
        "dx": -66,
        "dy": -29,
        "offsetTarget": "badge canvas top left"
      },
      "meaning": "18+ content notice; same in all selection and availability states"
    },
    {
      "id": "divider.who",
      "piece": "row.divider.png",
      "x": 108,
      "y": 1235,
      "w": 726,
      "h": 12,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 24,
        "bottom": 0,
        "left": 24
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight"
    },
    {
      "id": "chip.who.open",
      "piece": "create.pill.off",
      "x": 90,
      "y": 1136,
      "w": 206,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 102,
        "y": 1148,
        "w": 182,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.who.women",
      "piece": "create.pill.off",
      "x": 277.33333333333337,
      "y": 1136,
      "w": 206,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 289.33333333333337,
        "y": 1148,
        "w": 182,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.who.men",
      "piece": "create.pill.off",
      "x": 464.6666666666667,
      "y": 1136,
      "w": 206,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 476.6666666666667,
        "y": 1148,
        "w": 182,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.who.mix",
      "piece": "create.pill.off",
      "x": 652,
      "y": 1136,
      "w": 206,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 664,
        "y": 1148,
        "w": 182,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "divider.visibility",
      "piece": "row.divider.png",
      "x": 108,
      "y": 1395,
      "w": 726,
      "h": 12,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 24,
        "bottom": 0,
        "left": 24
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight"
    },
    {
      "id": "chip.visibility.link",
      "piece": "create.pill.off",
      "x": 90,
      "y": 1296,
      "w": 266,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 102,
        "y": 1308,
        "w": 242,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.visibility.friends",
      "piece": "create.pill.off",
      "x": 338,
      "y": 1296,
      "w": 268,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 350,
        "y": 1308,
        "w": 244,
        "h": 76
      },
      "visualOutsetStage": 12
    },
    {
      "id": "chip.visibility.public",
      "piece": "create.pill.off",
      "x": 586,
      "y": 1296,
      "w": 268,
      "h": 100,
      "render": "3-slice",
      "tint": "none",
      "z": 21,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "controlBoxStage": {
        "x": 598,
        "y": 1308,
        "w": 244,
        "h": 76
      },
      "visualOutsetStage": 12
    }
  ],
  "texts": [
    {
      "id": "lbl.players",
      "text": "PLAYERS",
      "role": "label",
      "className": "t-label cr-t-label",
      "x": 191,
      "y": 466,
      "w": 130,
      "h": 40,
      "capCenterY": 486,
      "maxW": 130,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible"
    },
    {
      "id": "lbl.rounds",
      "text": "ROUNDS",
      "role": "label",
      "className": "t-label cr-t-label",
      "x": 192,
      "y": 621,
      "w": 126,
      "h": 40,
      "capCenterY": 641,
      "maxW": 126,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible"
    },
    {
      "id": "lbl.pace",
      "text": "PACE",
      "role": "label",
      "className": "t-label cr-t-label",
      "x": 193,
      "y": 784.5,
      "w": 73,
      "h": 40,
      "capCenterY": 804.5,
      "maxW": 73,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible"
    },
    {
      "id": "lbl.vibe",
      "text": "VIBE",
      "role": "label",
      "className": "t-label cr-t-label",
      "x": 190,
      "y": 943,
      "w": 67,
      "h": 40,
      "capCenterY": 963,
      "maxW": 67,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible"
    },
    {
      "id": "lbl.date",
      "text": "DATE MODE",
      "role": "label",
      "className": "t-label cr-t-label",
      "x": 198,
      "y": 1426.5,
      "w": 175,
      "h": 40,
      "capCenterY": 1446.5,
      "maxW": 175,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible"
    },
    {
      "id": "date.sub",
      "text": "Just the two of you · up to 6 rounds",
      "role": "caption",
      "className": "t-caption cr-t-sub",
      "x": 197,
      "y": 1469,
      "w": 371,
      "h": 33,
      "capCenterY": 1485.5,
      "maxW": 371,
      "align": "left",
      "color": "#9fd8ff",
      "z": 46,
      "overflow": "visible"
    },
    {
      "id": "howto.label",
      "text": "HOW TO PLAY",
      "role": "button",
      "className": "t-button",
      "x": 378.27200000000005,
      "y": 1586,
      "w": 234,
      "h": 40,
      "capCenterY": 1606,
      "maxW": 234,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 30
    },
    {
      "id": "chip.p3.label",
      "text": "3",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 127,
      "y": 533.5,
      "w": 132,
      "h": 33,
      "capCenterY": 550,
      "maxW": 132,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.p4.label",
      "text": "4",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 311,
      "y": 533.5,
      "w": 132,
      "h": 33,
      "capCenterY": 550,
      "maxW": 132,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.p5.label",
      "text": "5",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 497,
      "y": 533.5,
      "w": 132,
      "h": 33,
      "capCenterY": 550,
      "maxW": 132,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.p6.label",
      "text": "6",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 683,
      "y": 533.5,
      "w": 132,
      "h": 33,
      "capCenterY": 550,
      "maxW": 132,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.r1.label",
      "text": "1",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 127,
      "y": 691.5,
      "w": 192,
      "h": 33,
      "capCenterY": 708,
      "maxW": 192,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.r2.label",
      "text": "2",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 375,
      "y": 691.5,
      "w": 194,
      "h": 33,
      "capCenterY": 708,
      "maxW": 194,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.r3.label",
      "text": "3",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 623,
      "y": 691.5,
      "w": 194,
      "h": 33,
      "capCenterY": 708,
      "maxW": 194,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.chill.label",
      "text": "CHILL",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 127,
      "y": 849.5,
      "w": 316,
      "h": 33,
      "capCenterY": 866,
      "maxW": 316,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.quick.label",
      "text": "QUICK",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 499,
      "y": 849.5,
      "w": 318,
      "h": 33,
      "capCenterY": 866,
      "maxW": 318,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.v1.label",
      "text": "FRIENDLY",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 127,
      "y": 1009.5,
      "w": 131.5,
      "h": 33,
      "capCenterY": 1026,
      "maxW": 131.5,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.v2.label",
      "text": "BOLDER",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 314.5,
      "y": 1009.5,
      "w": 131.5,
      "h": 33,
      "capCenterY": 1026,
      "maxW": 131.5,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.v3.label",
      "text": "FLIRTY",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 502,
      "y": 1009.5,
      "w": 131.5,
      "h": 33,
      "capCenterY": 1026,
      "maxW": 131.5,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.v4.label",
      "text": "NAUGHTY",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 689.5,
      "y": 1009.5,
      "w": 131.5,
      "h": 33,
      "capCenterY": 1026,
      "maxW": 131.5,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.pair.label",
      "text": "2",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 375,
      "y": 533.5,
      "w": 194,
      "h": 33,
      "capCenterY": 550,
      "maxW": 194,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "cta.busy",
      "text": "",
      "role": "caption",
      "className": "t-caption",
      "x": 180,
      "y": 1869.5,
      "w": 580,
      "h": 33,
      "capCenterY": 1886,
      "maxW": 580,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible"
    },
    {
      "id": "lbl.who",
      "text": "WHO CAN JOIN",
      "role": "label",
      "className": "t-label cr-t-label",
      "x": 102,
      "y": 1103,
      "w": 744,
      "h": 40,
      "capCenterY": 1123,
      "maxW": 744,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible"
    },
    {
      "id": "chip.who.open.label",
      "text": "OPEN",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 127,
      "y": 1169.5,
      "w": 132,
      "h": 33,
      "capCenterY": 1186,
      "maxW": 132,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.who.women.label",
      "text": "WOMEN",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 314.33333333333337,
      "y": 1169.5,
      "w": 132,
      "h": 33,
      "capCenterY": 1186,
      "maxW": 132,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.who.men.label",
      "text": "MEN",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 501.6666666666667,
      "y": 1169.5,
      "w": 132,
      "h": 33,
      "capCenterY": 1186,
      "maxW": 132,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.who.mix.label",
      "text": "MIX",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 689,
      "y": 1169.5,
      "w": 132,
      "h": 33,
      "capCenterY": 1186,
      "maxW": 132,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "lbl.visibility",
      "text": "VISIBILITY",
      "role": "label",
      "className": "t-label cr-t-label",
      "x": 102,
      "y": 1263,
      "w": 744,
      "h": 40,
      "capCenterY": 1283,
      "maxW": 744,
      "align": "left",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible"
    },
    {
      "id": "chip.visibility.link.label",
      "text": "LINK",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 127,
      "y": 1329.5,
      "w": 192,
      "h": 33,
      "capCenterY": 1346,
      "maxW": 192,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.visibility.friends.label",
      "text": "FRIENDS",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 375,
      "y": 1329.5,
      "w": 194,
      "h": 33,
      "capCenterY": 1346,
      "maxW": 194,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    },
    {
      "id": "chip.visibility.public.label",
      "text": "PUBLIC",
      "role": "chip",
      "className": "t-chip cr-t-chip",
      "x": 623,
      "y": 1329.5,
      "w": 194,
      "h": 33,
      "capCenterY": 1346,
      "maxW": 194,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 26,
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "paddingFromInnerEdge": 16,
      "innerEdgeSafetyInset": 9,
      "controlPadding": 25
    }
  ],
  "hitTargets": [
    {
      "id": "back",
      "x": 16,
      "y": 9,
      "w": 120,
      "h": 120,
      "action": "back-home",
      "ariaLabel": "Back",
      "enabled": true
    },
    {
      "id": "sound",
      "x": 812,
      "y": 9,
      "w": 120,
      "h": 120,
      "action": "toggle-sound",
      "ariaLabel": "Sound on",
      "enabled": true
    },
    {
      "id": "chip.p3",
      "x": 102,
      "y": 492,
      "w": 182,
      "h": 116,
      "action": "set-players",
      "ariaLabel": "3",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.p4",
      "x": 286,
      "y": 492,
      "w": 182,
      "h": 116,
      "action": "set-players",
      "ariaLabel": "4",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.p5",
      "x": 472,
      "y": 492,
      "w": 182,
      "h": 116,
      "action": "set-players",
      "ariaLabel": "5",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.p6",
      "x": 658,
      "y": 492,
      "w": 182,
      "h": 116,
      "action": "set-players",
      "ariaLabel": "6",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.r1",
      "x": 102,
      "y": 650,
      "w": 242,
      "h": 116,
      "action": "set-rounds",
      "ariaLabel": "1",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.r2",
      "x": 350,
      "y": 650,
      "w": 244,
      "h": 116,
      "action": "set-rounds",
      "ariaLabel": "2",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.r3",
      "x": 598,
      "y": 650,
      "w": 244,
      "h": 116,
      "action": "set-rounds",
      "ariaLabel": "3",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.chill",
      "x": 102,
      "y": 808,
      "w": 366,
      "h": 116,
      "action": "set-pace",
      "ariaLabel": "CHILL",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.quick",
      "x": 474,
      "y": 808,
      "w": 368,
      "h": 116,
      "action": "set-pace",
      "ariaLabel": "QUICK",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.v1",
      "x": 102,
      "y": 968,
      "w": 181.5,
      "h": 116,
      "action": "set-vibe",
      "ariaLabel": "FRIENDLY",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.v2",
      "x": 289.5,
      "y": 968,
      "w": 181.5,
      "h": 116,
      "action": "set-vibe",
      "ariaLabel": "BOLDER",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.v3",
      "x": 477,
      "y": 968,
      "w": 181.5,
      "h": 116,
      "action": "set-vibe",
      "ariaLabel": "FLIRTY",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.v4",
      "x": 664.5,
      "y": 968,
      "w": 181.5,
      "h": 116,
      "action": "set-vibe",
      "ariaLabel": "NAUGHTY",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.pair",
      "x": 350,
      "y": 492,
      "w": 244,
      "h": 116,
      "action": "keep-date-pair",
      "ariaLabel": "2",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "date",
      "x": 696,
      "y": 1410,
      "w": 148,
      "h": 116,
      "action": "toggle-date",
      "ariaLabel": "Date mode — just the two of you, up to 6 rounds",
      "enabled": true,
      "role": "switch",
      "ariaChecked": false
    },
    {
      "id": "howto",
      "x": 258.956,
      "y": 1546,
      "w": 423.088,
      "h": 116,
      "action": "how-to-play",
      "ariaLabel": "How to play",
      "enabled": true
    },
    {
      "id": "cta",
      "x": 36,
      "y": 1724,
      "w": 868,
      "h": 144,
      "action": "create-room",
      "ariaLabel": "Create room",
      "enabled": true
    },
    {
      "id": "chip.who.open",
      "x": 102,
      "y": 1128,
      "w": 182,
      "h": 116,
      "action": "set-who",
      "ariaLabel": "OPEN",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.who.women",
      "x": 289.33333333333337,
      "y": 1128,
      "w": 182,
      "h": 116,
      "action": "set-who",
      "ariaLabel": "WOMEN",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.who.men",
      "x": 476.6666666666667,
      "y": 1128,
      "w": 182,
      "h": 116,
      "action": "set-who",
      "ariaLabel": "MEN",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.who.mix",
      "x": 664,
      "y": 1128,
      "w": 182,
      "h": 116,
      "action": "set-who",
      "ariaLabel": "MIX",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.visibility.link",
      "x": 102,
      "y": 1288,
      "w": 242,
      "h": 116,
      "action": "set-visibility",
      "ariaLabel": "LINK",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.visibility.friends",
      "x": 350,
      "y": 1288,
      "w": 244,
      "h": 116,
      "action": "set-visibility",
      "ariaLabel": "FRIENDS",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    },
    {
      "id": "chip.visibility.public",
      "x": 598,
      "y": 1288,
      "w": 244,
      "h": 116,
      "action": "set-visibility",
      "ariaLabel": "PUBLIC",
      "enabled": true,
      "role": "radio",
      "ariaChecked": false
    }
  ],
  "seatVariants": {},
  "states": {
    "friends": {
      "elementOverrides": {
        "chip.p3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p4": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p5": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p6": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.r1": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r2": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r3": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.chill": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.quick": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v1": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.v2": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v4": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.pair": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "date.switch": {
          "piece": "create.date.switch.off"
        },
        "title": {
          "filter": "none"
        },
        "background": {
          "piece": "apps/client/public/art/lobby-bg/friends.png",
          "x": 0,
          "y": 0,
          "w": 941,
          "h": 1672
        },
        "logo": {
          "piece": "apps/client/public/art/room-logos/lobby-friends.png",
          "x": 267,
          "y": 8,
          "w": 440,
          "h": 250
        },
        "sticker.ul": {
          "piece": "apps/client/public/art/lobby-kit/slogan.friends.l.png",
          "x": 44,
          "y": 130,
          "w": 170,
          "h": 182.467
        },
        "sticker.ur": {
          "piece": "apps/client/public/art/lobby-kit/slogan.friends.r.png",
          "x": 739,
          "y": 127,
          "w": 170,
          "h": 185.559
        },
        "chip.who.open": {
          "piece": "create.pill.on",
          "tint": "none"
        },
        "chip.who.women": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.who.men": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.who.mix": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.link": {
          "piece": "create.pill.on",
          "tint": "none"
        },
        "chip.visibility.friends": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.public": {
          "piece": "create.pill.off",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.p3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p4.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p5.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p6.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.r1.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.r2.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.r3.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.chill.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.quick.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v1.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.v2.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v4.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.pair.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.who.open.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip on off"
        },
        "chip.who.women.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.men.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.mix.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.visibility.link.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.visibility.friends.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.visibility.public.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "lbl.who": {
          "color": "#6f7ba8"
        }
      },
      "hitOverrides": {
        "chip.pair": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.p3": {
          "ariaChecked": false
        },
        "chip.p4": {
          "ariaChecked": false
        },
        "chip.p5": {
          "ariaChecked": false
        },
        "chip.p6": {
          "ariaChecked": true
        },
        "chip.r1": {
          "ariaChecked": false
        },
        "chip.r2": {
          "ariaChecked": false
        },
        "chip.r3": {
          "ariaChecked": true
        },
        "chip.chill": {
          "ariaChecked": true
        },
        "chip.quick": {
          "ariaChecked": false
        },
        "chip.v1": {
          "ariaChecked": true
        },
        "chip.v2": {
          "ariaChecked": false
        },
        "chip.v3": {
          "ariaChecked": false
        },
        "chip.v4": {
          "ariaChecked": false
        },
        "date": {
          "ariaChecked": false
        },
        "chip.who.open": {
          "enabled": false,
          "action": null,
          "ariaChecked": true
        },
        "chip.who.women": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.who.men": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.who.mix": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.visibility.link": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": true
        },
        "chip.visibility.friends": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": false
        },
        "chip.visibility.public": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": false
        }
      },
      "hiddenElements": [
        "chip.pair"
      ],
      "hiddenTexts": [
        "chip.pair.label"
      ],
      "when": "date == false",
      "values": {
        "date": false,
        "players": 6,
        "lines": 3,
        "dateLines": 6,
        "pace": "chill",
        "vibe": "friendly",
        "busy": false,
        "who": "open",
        "visibility": "link"
      }
    },
    "date": {
      "elementOverrides": {
        "chip.p3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p4": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p5": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p6": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r1": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r2": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r3": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.chill": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.quick": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v1": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.v2": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v4": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.pair": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "date.switch": {
          "piece": "create.date.switch.on"
        },
        "title": {
          "filter": "contrast(0.9) sepia(1) brightness(0.61) saturate(10) hue-rotate(338.5deg)"
        },
        "background": {
          "piece": "apps/client/public/art/lobby-bg/date.png",
          "x": 0,
          "y": 0,
          "w": 941,
          "h": 1672
        },
        "logo": {
          "piece": "apps/client/public/art/room-logos/lobby-date.png",
          "x": 267,
          "y": 8,
          "w": 440,
          "h": 260.5
        },
        "sticker.ul": {
          "piece": "apps/client/public/art/lobby-kit/slogan.date.l.png",
          "x": 34,
          "y": 142,
          "w": 185,
          "h": 152
        },
        "sticker.ur": {
          "piece": "apps/client/public/art/lobby-kit/slogan.date.r.png",
          "x": 740,
          "y": 126,
          "w": 170,
          "h": 150.948
        },
        "chip.who.open": {
          "piece": "create.pill.on",
          "tint": "none"
        },
        "chip.who.women": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.who.men": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.who.mix": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.link": {
          "piece": "create.pill.on",
          "tint": "none"
        },
        "chip.visibility.friends": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.public": {
          "piece": "create.pill.off",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.p3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p4.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p5.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p6.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.r1.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip",
          "text": "2"
        },
        "chip.r2.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip",
          "text": "4"
        },
        "chip.r3.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on",
          "text": "6"
        },
        "chip.chill.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.quick.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v1.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on",
          "text": "DATING"
        },
        "chip.v2.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v4.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.pair.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.who.open.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip on off"
        },
        "chip.who.women.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.men.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.mix.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.visibility.link.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.visibility.friends.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.visibility.public.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "lbl.who": {
          "color": "#6f7ba8"
        }
      },
      "hitOverrides": {
        "chip.p3": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.p4": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.p5": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.p6": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.r1": {
          "ariaChecked": false,
          "ariaLabel": "2"
        },
        "chip.r2": {
          "ariaChecked": false,
          "ariaLabel": "4"
        },
        "chip.r3": {
          "ariaChecked": true,
          "ariaLabel": "6"
        },
        "chip.chill": {
          "ariaChecked": true
        },
        "chip.quick": {
          "ariaChecked": false
        },
        "chip.v1": {
          "ariaChecked": true,
          "ariaLabel": "DATING"
        },
        "chip.v2": {
          "ariaChecked": false
        },
        "chip.v3": {
          "ariaChecked": false
        },
        "chip.v4": {
          "ariaChecked": false
        },
        "chip.pair": {
          "ariaChecked": true
        },
        "date": {
          "ariaChecked": true
        },
        "cta": {
          "ariaLabel": "Create the Date"
        },
        "chip.who.open": {
          "enabled": false,
          "action": null,
          "ariaChecked": true
        },
        "chip.who.women": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.who.men": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.who.mix": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.visibility.link": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": true
        },
        "chip.visibility.friends": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": false
        },
        "chip.visibility.public": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": false
        }
      },
      "hiddenElements": [
        "chip.p3",
        "chip.p4",
        "chip.p5",
        "chip.p6"
      ],
      "hiddenTexts": [
        "chip.p3.label",
        "chip.p4.label",
        "chip.p5.label",
        "chip.p6.label"
      ],
      "when": "date == true",
      "values": {
        "date": true,
        "players": 6,
        "lines": 3,
        "dateLines": 6,
        "pace": "chill",
        "vibe": "dating",
        "busy": false,
        "who": "open",
        "visibility": "link"
      }
    },
    "empty": {
      "elementOverrides": {
        "chip.p3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p4": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p5": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p6": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r1": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r2": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.chill": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.quick": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v1": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v2": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v4": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.pair": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "date.switch": {
          "piece": "create.date.switch.off"
        },
        "chip.who.open": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.who.women": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.who.men": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.who.mix": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.link": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.friends": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.public": {
          "piece": "create.pill.off",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.p3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p4.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p5.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p6.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.r1.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.r2.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.r3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.chill.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.quick.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v1.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v2.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v4.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.pair.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.who.open.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.women.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.men.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.mix.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.visibility.link.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.visibility.friends.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.visibility.public.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "lbl.who": {
          "color": "#6f7ba8"
        }
      },
      "hitOverrides": {
        "chip.pair": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.p3": {
          "ariaChecked": false
        },
        "chip.p4": {
          "ariaChecked": false
        },
        "chip.p5": {
          "ariaChecked": false
        },
        "chip.p6": {
          "ariaChecked": false
        },
        "chip.r1": {
          "ariaChecked": false
        },
        "chip.r2": {
          "ariaChecked": false
        },
        "chip.r3": {
          "ariaChecked": false
        },
        "chip.chill": {
          "ariaChecked": false
        },
        "chip.quick": {
          "ariaChecked": false
        },
        "chip.v1": {
          "ariaChecked": false
        },
        "chip.v2": {
          "ariaChecked": false
        },
        "chip.v3": {
          "ariaChecked": false
        },
        "chip.v4": {
          "ariaChecked": false
        },
        "date": {
          "ariaChecked": false
        },
        "cta": {
          "enabled": false,
          "action": null
        },
        "chip.who.open": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.who.women": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.who.men": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.who.mix": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.visibility.link": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": false
        },
        "chip.visibility.friends": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": false
        },
        "chip.visibility.public": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": false
        }
      },
      "hiddenElements": [
        "chip.pair"
      ],
      "hiddenTexts": [
        "chip.pair.label"
      ],
      "when": "catalogue fixture only: empty",
      "values": {
        "date": false,
        "players": null,
        "lines": null,
        "dateLines": 6,
        "pace": null,
        "vibe": null,
        "busy": false,
        "who": null,
        "visibility": null
      }
    },
    "invalid": {
      "elementOverrides": {
        "chip.p3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p4": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p5": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p6": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.r1": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r2": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.chill": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.quick": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v1": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.v2": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v4": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.pair": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "date.switch": {
          "piece": "create.date.switch.off"
        },
        "chip.who.open": {
          "piece": "create.pill.on",
          "tint": "none"
        },
        "chip.who.women": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.who.men": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.who.mix": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.link": {
          "piece": "create.pill.on",
          "tint": "none"
        },
        "chip.visibility.friends": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.public": {
          "piece": "create.pill.off",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.p3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p4.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p5.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p6.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.r1.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.r2.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.r3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.chill.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.quick.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v1.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.v2.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v4.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.pair.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.who.open.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip on off"
        },
        "chip.who.women.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.men.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.mix.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.visibility.link.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.visibility.friends.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.visibility.public.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "lbl.who": {
          "color": "#6f7ba8"
        }
      },
      "hitOverrides": {
        "chip.pair": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.p3": {
          "ariaChecked": false
        },
        "chip.p4": {
          "ariaChecked": false
        },
        "chip.p5": {
          "ariaChecked": false
        },
        "chip.p6": {
          "ariaChecked": true
        },
        "chip.r1": {
          "ariaChecked": false
        },
        "chip.r2": {
          "ariaChecked": false
        },
        "chip.r3": {
          "ariaChecked": false
        },
        "chip.chill": {
          "ariaChecked": true
        },
        "chip.quick": {
          "ariaChecked": false
        },
        "chip.v1": {
          "ariaChecked": true
        },
        "chip.v2": {
          "ariaChecked": false
        },
        "chip.v3": {
          "ariaChecked": false
        },
        "chip.v4": {
          "ariaChecked": false
        },
        "date": {
          "ariaChecked": false
        },
        "cta": {
          "enabled": false,
          "action": null
        },
        "chip.who.open": {
          "enabled": false,
          "action": null,
          "ariaChecked": true
        },
        "chip.who.women": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.who.men": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.who.mix": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.visibility.link": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": true
        },
        "chip.visibility.friends": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": false
        },
        "chip.visibility.public": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": false
        }
      },
      "hiddenElements": [
        "chip.pair"
      ],
      "hiddenTexts": [
        "chip.pair.label"
      ],
      "when": "catalogue fixture only: invalid",
      "values": {
        "date": false,
        "players": 6,
        "lines": null,
        "dateLines": 6,
        "pace": "chill",
        "vibe": "friendly",
        "busy": false,
        "who": "open",
        "visibility": "link"
      }
    },
    "disabled": {
      "elementOverrides": {
        "chip.p3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p4": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p5": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p6": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.r1": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r2": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r3": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.chill": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.quick": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v1": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.v2": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v4": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.pair": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "date.switch": {
          "piece": "create.date.switch.off"
        },
        "cta.lettering": {
          "opacity": 0.55
        },
        "chip.who.open": {
          "piece": "create.pill.on",
          "tint": "none"
        },
        "chip.who.women": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.who.men": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.who.mix": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.link": {
          "piece": "create.pill.on",
          "tint": "none"
        },
        "chip.visibility.friends": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.public": {
          "piece": "create.pill.off",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.p3.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.p4.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.p5.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.p6.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip on off"
        },
        "chip.r1.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.r2.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.r3.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip on off"
        },
        "chip.chill.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip on off"
        },
        "chip.quick.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.v1.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip on off"
        },
        "chip.v2.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.v3.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.v4.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.pair.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.open.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip on off"
        },
        "chip.who.women.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.men.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.mix.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.visibility.link.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip on off"
        },
        "chip.visibility.friends.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.visibility.public.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "lbl.who": {
          "color": "#6f7ba8"
        }
      },
      "hitOverrides": {
        "chip.pair": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.p3": {
          "ariaChecked": false,
          "enabled": false,
          "action": null
        },
        "chip.p4": {
          "ariaChecked": false,
          "enabled": false,
          "action": null
        },
        "chip.p5": {
          "ariaChecked": false,
          "enabled": false,
          "action": null
        },
        "chip.p6": {
          "ariaChecked": true,
          "enabled": false,
          "action": null
        },
        "chip.r1": {
          "ariaChecked": false,
          "enabled": false,
          "action": null
        },
        "chip.r2": {
          "ariaChecked": false,
          "enabled": false,
          "action": null
        },
        "chip.r3": {
          "ariaChecked": true,
          "enabled": false,
          "action": null
        },
        "chip.chill": {
          "ariaChecked": true,
          "enabled": false,
          "action": null
        },
        "chip.quick": {
          "ariaChecked": false,
          "enabled": false,
          "action": null
        },
        "chip.v1": {
          "ariaChecked": true,
          "enabled": false,
          "action": null
        },
        "chip.v2": {
          "ariaChecked": false,
          "enabled": false,
          "action": null
        },
        "chip.v3": {
          "ariaChecked": false,
          "enabled": false,
          "action": null
        },
        "chip.v4": {
          "ariaChecked": false,
          "enabled": false,
          "action": null
        },
        "date": {
          "ariaChecked": false,
          "enabled": false,
          "action": null
        },
        "cta": {
          "enabled": false,
          "action": null
        },
        "chip.who.open": {
          "enabled": false,
          "action": null,
          "ariaChecked": true
        },
        "chip.who.women": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.who.men": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.who.mix": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.visibility.link": {
          "enabled": false,
          "action": null,
          "ariaChecked": true
        },
        "chip.visibility.friends": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.visibility.public": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        }
      },
      "hiddenElements": [
        "chip.pair"
      ],
      "hiddenTexts": [
        "chip.pair.label"
      ],
      "when": "catalogue fixture only: disabled",
      "values": {
        "date": false,
        "players": 6,
        "lines": 3,
        "dateLines": 6,
        "pace": "chill",
        "vibe": "friendly",
        "busy": false,
        "who": "open",
        "visibility": "link"
      }
    },
    "friends_public": {
      "elementOverrides": {
        "chip.p3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p4": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p5": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.p6": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.r1": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r2": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.r3": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.chill": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.quick": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v1": {
          "tint": "none",
          "piece": "create.pill.on"
        },
        "chip.v2": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v3": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.v4": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "chip.pair": {
          "tint": "none",
          "piece": "create.pill.off"
        },
        "date.switch": {
          "piece": "create.date.switch.off"
        },
        "title": {
          "filter": "none"
        },
        "background": {
          "piece": "apps/client/public/art/lobby-bg/friends.png",
          "x": 0,
          "y": 0,
          "w": 941,
          "h": 1672
        },
        "logo": {
          "piece": "apps/client/public/art/room-logos/lobby-friends.png",
          "x": 267,
          "y": 8,
          "w": 440,
          "h": 250
        },
        "sticker.ul": {
          "piece": "apps/client/public/art/lobby-kit/slogan.friends.l.png",
          "x": 44,
          "y": 130,
          "w": 170,
          "h": 182.467
        },
        "sticker.ur": {
          "piece": "apps/client/public/art/lobby-kit/slogan.friends.r.png",
          "x": 739,
          "y": 127,
          "w": 170,
          "h": 185.559
        },
        "chip.who.open": {
          "piece": "create.pill.on",
          "tint": "none"
        },
        "chip.who.women": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.who.men": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.who.mix": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.link": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.friends": {
          "piece": "create.pill.off",
          "tint": "none"
        },
        "chip.visibility.public": {
          "piece": "create.pill.on",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.p3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p4.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p5.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.p6.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.r1.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.r2.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.r3.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.chill.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.quick.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v1.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.v2.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.v4.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.pair.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.who.open.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "chip.who.women.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.who.men.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.who.mix.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.visibility.link.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.visibility.friends.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        },
        "chip.visibility.public.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        },
        "lbl.who": {
          "color": "#ffffff"
        }
      },
      "hitOverrides": {
        "chip.pair": {
          "enabled": false,
          "action": null,
          "ariaChecked": false
        },
        "chip.p3": {
          "ariaChecked": false
        },
        "chip.p4": {
          "ariaChecked": false
        },
        "chip.p5": {
          "ariaChecked": false
        },
        "chip.p6": {
          "ariaChecked": true
        },
        "chip.r1": {
          "ariaChecked": false
        },
        "chip.r2": {
          "ariaChecked": false
        },
        "chip.r3": {
          "ariaChecked": true
        },
        "chip.chill": {
          "ariaChecked": true
        },
        "chip.quick": {
          "ariaChecked": false
        },
        "chip.v1": {
          "ariaChecked": true
        },
        "chip.v2": {
          "ariaChecked": false
        },
        "chip.v3": {
          "ariaChecked": false
        },
        "chip.v4": {
          "ariaChecked": false
        },
        "date": {
          "ariaChecked": false
        },
        "chip.who.open": {
          "enabled": true,
          "action": "set-who",
          "ariaChecked": true
        },
        "chip.who.women": {
          "enabled": true,
          "action": "set-who",
          "ariaChecked": false
        },
        "chip.who.men": {
          "enabled": true,
          "action": "set-who",
          "ariaChecked": false
        },
        "chip.who.mix": {
          "enabled": true,
          "action": "set-who",
          "ariaChecked": false
        },
        "chip.visibility.link": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": false
        },
        "chip.visibility.friends": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": false
        },
        "chip.visibility.public": {
          "enabled": true,
          "action": "set-visibility",
          "ariaChecked": true
        }
      },
      "hiddenElements": [
        "chip.pair"
      ],
      "hiddenTexts": [
        "chip.pair.label"
      ],
      "when": "date == false",
      "values": {
        "date": false,
        "players": 6,
        "lines": 3,
        "dateLines": 6,
        "pace": "chill",
        "vibe": "friendly",
        "busy": false,
        "who": "open",
        "visibility": "public"
      }
    }
  },
  "examples": [
    {
      "id": "friends_default",
      "state": "friends",
      "theme": "friends"
    },
    {
      "id": "friends_alternate",
      "state": "friends",
      "theme": "friends",
      "values": {
        "date": false,
        "players": 3,
        "lines": 1,
        "dateLines": 6,
        "pace": "quick",
        "vibe": "naughty",
        "busy": false,
        "who": "open",
        "visibility": "link"
      }
    },
    {
      "id": "date_default",
      "state": "date",
      "theme": "friends"
    },
    {
      "id": "date_alternate",
      "state": "date",
      "theme": "friends",
      "values": {
        "date": true,
        "players": 4,
        "lines": 2,
        "dateLines": 2,
        "pace": "quick",
        "vibe": "flirty",
        "busy": false,
        "who": "open",
        "visibility": "link"
      }
    },
    {
      "id": "empty",
      "state": "empty",
      "theme": "friends"
    },
    {
      "id": "invalid",
      "state": "invalid",
      "theme": "friends"
    },
    {
      "id": "disabled",
      "state": "disabled",
      "theme": "friends"
    },
    {
      "id": "busy_friends",
      "state": "friends",
      "theme": "friends",
      "auxiliaryStates": [
        "busy"
      ]
    },
    {
      "id": "busy_date",
      "state": "date",
      "theme": "friends",
      "auxiliaryStates": [
        "busy"
      ]
    },
    {
      "id": "create_error",
      "state": "friends",
      "theme": "friends",
      "auxiliaryStates": [
        "create_error"
      ]
    },
    {
      "id": "sound_off",
      "state": "friends",
      "theme": "friends",
      "auxiliaryStates": [
        "sound_off"
      ]
    },
    {
      "id": "friends_public",
      "state": "friends_public",
      "theme": "friends"
    },
    {
      "id": "friends_visibility_friends",
      "state": "friends",
      "theme": "friends",
      "values": {
        "date": false,
        "players": 6,
        "lines": 3,
        "dateLines": 6,
        "pace": "chill",
        "vibe": "friendly",
        "busy": false,
        "who": "open",
        "visibility": "friends"
      },
      "auxiliaryStates": [
        "chip.visibility.link.unselected",
        "chip.visibility.friends.selected",
        "who.disabled"
      ]
    }
  ],
  "measurements": {
    "source": "layout-create.json",
    "values": "VALUES-create-4.md",
    "verification": "layout-create.json#/verification",
    "font": "apps/client/public/fonts/Nunito-latin.woff2",
    "minimumFontSizeAt360": 41.82222222222222,
    "chipMarginReason": "Actual source neon boundaries measured at rendered pill height 100 and 12-unit visual outset; fixed 25-unit text inset. WHO widths182 in same744 lane with16/3 gaps."
  },
  "notes": [
    "Only existing artwork reused; no new icons for WHO CAN JOIN or VISIBILITY. Labels start at the chip lane x102.",
    "Scene, logo, slogans and title remain at baseline geometry. Background ends at1672; existing page navy is exposed below.",
    "Previews are flattened layout reviews; each source element remains separate in JSON.",
    "Chip image canvases include transparent glow padding and may overlap; interactive controls and measured neon bodies do not.",
    "Only the four requested outputs are delivered. No application code or existing artwork changed.",
    "Revision 4: HOW TO PLAY uses the exact centered lobby plate width423.088, height104, room tint, info icon and white button30 label. Both old explanatory caption lines removed. The 116-high hit area extends6 above and below the plate. CTA and page height unchanged."
  ],
  "auxiliaryStates": {
    "chip.p3.unselected": {
      "elementOverrides": {
        "chip.p3": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.p3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.p3": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "p3 is unselected in its visible radio group"
    },
    "chip.p3.selected": {
      "elementOverrides": {
        "chip.p3": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.p3.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.p3": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "p3 is selected in its visible radio group"
    },
    "chip.p4.unselected": {
      "elementOverrides": {
        "chip.p4": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.p4.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.p4": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "p4 is unselected in its visible radio group"
    },
    "chip.p4.selected": {
      "elementOverrides": {
        "chip.p4": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.p4.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.p4": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "p4 is selected in its visible radio group"
    },
    "chip.p5.unselected": {
      "elementOverrides": {
        "chip.p5": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.p5.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.p5": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "p5 is unselected in its visible radio group"
    },
    "chip.p5.selected": {
      "elementOverrides": {
        "chip.p5": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.p5.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.p5": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "p5 is selected in its visible radio group"
    },
    "chip.p6.unselected": {
      "elementOverrides": {
        "chip.p6": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.p6.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.p6": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "p6 is unselected in its visible radio group"
    },
    "chip.p6.selected": {
      "elementOverrides": {
        "chip.p6": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.p6.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.p6": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "p6 is selected in its visible radio group"
    },
    "chip.r1.unselected": {
      "elementOverrides": {
        "chip.r1": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.r1.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.r1": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "r1 is unselected in its visible radio group"
    },
    "chip.r1.selected": {
      "elementOverrides": {
        "chip.r1": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.r1.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.r1": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "r1 is selected in its visible radio group"
    },
    "chip.r2.unselected": {
      "elementOverrides": {
        "chip.r2": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.r2.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.r2": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "r2 is unselected in its visible radio group"
    },
    "chip.r2.selected": {
      "elementOverrides": {
        "chip.r2": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.r2.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.r2": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "r2 is selected in its visible radio group"
    },
    "chip.r3.unselected": {
      "elementOverrides": {
        "chip.r3": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.r3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.r3": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "r3 is unselected in its visible radio group"
    },
    "chip.r3.selected": {
      "elementOverrides": {
        "chip.r3": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.r3.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.r3": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "r3 is selected in its visible radio group"
    },
    "chip.chill.unselected": {
      "elementOverrides": {
        "chip.chill": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.chill.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.chill": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chill is unselected in its visible radio group"
    },
    "chip.chill.selected": {
      "elementOverrides": {
        "chip.chill": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.chill.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.chill": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chill is selected in its visible radio group"
    },
    "chip.quick.unselected": {
      "elementOverrides": {
        "chip.quick": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.quick.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.quick": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "quick is unselected in its visible radio group"
    },
    "chip.quick.selected": {
      "elementOverrides": {
        "chip.quick": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.quick.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.quick": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "quick is selected in its visible radio group"
    },
    "chip.v1.unselected": {
      "elementOverrides": {
        "chip.v1": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.v1.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.v1": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "v1 is unselected in its visible radio group"
    },
    "chip.v1.selected": {
      "elementOverrides": {
        "chip.v1": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.v1.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.v1": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "v1 is selected in its visible radio group"
    },
    "chip.v2.unselected": {
      "elementOverrides": {
        "chip.v2": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.v2.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.v2": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "v2 is unselected in its visible radio group"
    },
    "chip.v2.selected": {
      "elementOverrides": {
        "chip.v2": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.v2.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.v2": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "v2 is selected in its visible radio group"
    },
    "chip.v3.unselected": {
      "elementOverrides": {
        "chip.v3": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.v3.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.v3": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "v3 is unselected in its visible radio group"
    },
    "chip.v3.selected": {
      "elementOverrides": {
        "chip.v3": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.v3.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.v3": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "v3 is selected in its visible radio group"
    },
    "chip.v4.unselected": {
      "elementOverrides": {
        "chip.v4": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.v4.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.v4": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "v4 is unselected in its visible radio group"
    },
    "chip.v4.selected": {
      "elementOverrides": {
        "chip.v4": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.v4.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.v4": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "v4 is selected in its visible radio group"
    },
    "chip.pair.unselected": {
      "elementOverrides": {
        "chip.pair": {
          "tint": "none",
          "piece": "create.pill.off"
        }
      },
      "textOverrides": {
        "chip.pair.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.pair": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "pair is unselected in its visible radio group"
    },
    "chip.pair.selected": {
      "elementOverrides": {
        "chip.pair": {
          "tint": "none",
          "piece": "create.pill.on"
        }
      },
      "textOverrides": {
        "chip.pair.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.pair": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "pair is selected in its visible radio group"
    },
    "date_off": {
      "elementOverrides": {
        "date.switch": {
          "piece": "create.date.switch.off"
        },
        "title": {
          "filter": "none"
        },
        "background": {
          "piece": "apps/client/public/art/lobby-bg/friends.png",
          "x": 0,
          "y": 0,
          "w": 941,
          "h": 1672
        },
        "logo": {
          "piece": "apps/client/public/art/room-logos/lobby-friends.png",
          "x": 267,
          "y": 8,
          "w": 440,
          "h": 250
        },
        "sticker.ul": {
          "piece": "apps/client/public/art/lobby-kit/slogan.friends.l.png",
          "x": 44,
          "y": 130,
          "w": 170,
          "h": 182.467
        },
        "sticker.ur": {
          "piece": "apps/client/public/art/lobby-kit/slogan.friends.r.png",
          "x": 739,
          "y": 127,
          "w": 170,
          "h": 185.559
        }
      },
      "textOverrides": {},
      "hitOverrides": {
        "date": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "date == false"
    },
    "date_on": {
      "elementOverrides": {
        "date.switch": {
          "piece": "create.date.switch.on"
        },
        "title": {
          "filter": "contrast(0.9) sepia(1) brightness(0.61) saturate(10) hue-rotate(338.5deg)"
        },
        "background": {
          "piece": "apps/client/public/art/lobby-bg/date.png",
          "x": 0,
          "y": 0,
          "w": 941,
          "h": 1672
        },
        "logo": {
          "piece": "apps/client/public/art/room-logos/lobby-date.png",
          "x": 267,
          "y": 8,
          "w": 440,
          "h": 260.5
        },
        "sticker.ul": {
          "piece": "apps/client/public/art/lobby-kit/slogan.date.l.png",
          "x": 34,
          "y": 142,
          "w": 185,
          "h": 152
        },
        "sticker.ur": {
          "piece": "apps/client/public/art/lobby-kit/slogan.date.r.png",
          "x": 740,
          "y": 126,
          "w": 170,
          "h": 150.948
        }
      },
      "textOverrides": {},
      "hitOverrides": {
        "date": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "date == true"
    },
    "busy": {
      "elementOverrides": {
        "cta.plate": {
          "opacity": 0.5
        },
        "cta.lettering": {
          "opacity": 0.55
        }
      },
      "textOverrides": {
        "cta.busy": {
          "text": "Opening…"
        }
      },
      "hitOverrides": {
        "cta": {
          "enabled": false,
          "action": null
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "busy"
    },
    "create_error": {
      "elementOverrides": {
        "cta.plate": {
          "opacity": 1
        },
        "cta.lettering": {
          "opacity": 1
        }
      },
      "textOverrides": {
        "cta.busy": {
          "text": ""
        }
      },
      "hitOverrides": {
        "cta": {
          "enabled": true,
          "action": "create-room"
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "create failed and busy is false; selections retained"
    },
    "sound_off": {
      "elementOverrides": {
        "sound.icon": {
          "piece": "apps/client/public/art/ui-head/icon-sound-off@2x.png"
        }
      },
      "textOverrides": {},
      "hitOverrides": {
        "sound": {
          "ariaLabel": "Sound off"
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "muted"
    },
    "chip.who.open.unselected": {
      "elementOverrides": {
        "chip.who.open": {
          "piece": "create.pill.off",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.who.open.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.who.open": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.who.open is unselected"
    },
    "chip.who.open.selected": {
      "elementOverrides": {
        "chip.who.open": {
          "piece": "create.pill.on",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.who.open.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.who.open": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.who.open is selected"
    },
    "chip.who.women.unselected": {
      "elementOverrides": {
        "chip.who.women": {
          "piece": "create.pill.off",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.who.women.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.who.women": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.who.women is unselected"
    },
    "chip.who.women.selected": {
      "elementOverrides": {
        "chip.who.women": {
          "piece": "create.pill.on",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.who.women.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.who.women": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.who.women is selected"
    },
    "chip.who.men.unselected": {
      "elementOverrides": {
        "chip.who.men": {
          "piece": "create.pill.off",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.who.men.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.who.men": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.who.men is unselected"
    },
    "chip.who.men.selected": {
      "elementOverrides": {
        "chip.who.men": {
          "piece": "create.pill.on",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.who.men.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.who.men": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.who.men is selected"
    },
    "chip.who.mix.unselected": {
      "elementOverrides": {
        "chip.who.mix": {
          "piece": "create.pill.off",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.who.mix.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.who.mix": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.who.mix is unselected"
    },
    "chip.who.mix.selected": {
      "elementOverrides": {
        "chip.who.mix": {
          "piece": "create.pill.on",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.who.mix.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.who.mix": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.who.mix is selected"
    },
    "chip.visibility.link.unselected": {
      "elementOverrides": {
        "chip.visibility.link": {
          "piece": "create.pill.off",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.visibility.link.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.visibility.link": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.visibility.link is unselected"
    },
    "chip.visibility.link.selected": {
      "elementOverrides": {
        "chip.visibility.link": {
          "piece": "create.pill.on",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.visibility.link.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.visibility.link": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.visibility.link is selected"
    },
    "chip.visibility.friends.unselected": {
      "elementOverrides": {
        "chip.visibility.friends": {
          "piece": "create.pill.off",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.visibility.friends.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.visibility.friends": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.visibility.friends is unselected"
    },
    "chip.visibility.friends.selected": {
      "elementOverrides": {
        "chip.visibility.friends": {
          "piece": "create.pill.on",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.visibility.friends.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.visibility.friends": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.visibility.friends is selected"
    },
    "chip.visibility.public.unselected": {
      "elementOverrides": {
        "chip.visibility.public": {
          "piece": "create.pill.off",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.visibility.public.label": {
          "color": "#ffffff",
          "className": "t-chip cr-t-chip"
        }
      },
      "hitOverrides": {
        "chip.visibility.public": {
          "ariaChecked": false
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.visibility.public is unselected"
    },
    "chip.visibility.public.selected": {
      "elementOverrides": {
        "chip.visibility.public": {
          "piece": "create.pill.on",
          "tint": "none"
        }
      },
      "textOverrides": {
        "chip.visibility.public.label": {
          "color": "#ffe36a",
          "className": "t-chip cr-t-chip on"
        }
      },
      "hitOverrides": {
        "chip.visibility.public": {
          "ariaChecked": true
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "chip.visibility.public is selected"
    },
    "who.enabled": {
      "elementOverrides": {},
      "textOverrides": {
        "lbl.who": {
          "color": "#ffffff"
        }
      },
      "hitOverrides": {
        "chip.who.open": {
          "enabled": true,
          "action": "set-who"
        },
        "chip.who.women": {
          "enabled": true,
          "action": "set-who"
        },
        "chip.who.men": {
          "enabled": true,
          "action": "set-who"
        },
        "chip.who.mix": {
          "enabled": true,
          "action": "set-who"
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "visibility == public and not disabled",
      "selectionPreserved": true
    },
    "who.disabled": {
      "elementOverrides": {},
      "textOverrides": {
        "lbl.who": {
          "color": "#6f7ba8"
        },
        "chip.who.open.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.women.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.men.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        },
        "chip.who.mix.label": {
          "color": "#6f7ba8",
          "className": "t-chip cr-t-chip off"
        }
      },
      "hitOverrides": {
        "chip.who.open": {
          "enabled": false,
          "action": null
        },
        "chip.who.women": {
          "enabled": false,
          "action": null
        },
        "chip.who.men": {
          "enabled": false,
          "action": null
        },
        "chip.who.mix": {
          "enabled": false,
          "action": null
        }
      },
      "hiddenElements": [],
      "hiddenTexts": [],
      "when": "visibility != public or disabled; apply after radio selection",
      "selectionPreserved": true
    }
  },
  "stateSelection": {
    "priority": [
      "disabled",
      "invalid",
      "empty",
      "date",
      "friends"
    ],
    "orthogonal": [
      "chip.p3.unselected",
      "chip.p3.selected",
      "chip.p4.unselected",
      "chip.p4.selected",
      "chip.p5.unselected",
      "chip.p5.selected",
      "chip.p6.unselected",
      "chip.p6.selected",
      "chip.r1.unselected",
      "chip.r1.selected",
      "chip.r2.unselected",
      "chip.r2.selected",
      "chip.r3.unselected",
      "chip.r3.selected",
      "chip.chill.unselected",
      "chip.chill.selected",
      "chip.quick.unselected",
      "chip.quick.selected",
      "chip.v1.unselected",
      "chip.v1.selected",
      "chip.v2.unselected",
      "chip.v2.selected",
      "chip.v3.unselected",
      "chip.v3.selected",
      "chip.v4.unselected",
      "chip.v4.selected",
      "chip.pair.unselected",
      "chip.pair.selected",
      "date_off",
      "date_on",
      "busy",
      "create_error",
      "sound_off",
      "chip.who.open.unselected",
      "chip.who.open.selected",
      "chip.who.women.unselected",
      "chip.who.women.selected",
      "chip.who.men.unselected",
      "chip.who.men.selected",
      "chip.who.mix.unselected",
      "chip.who.mix.selected",
      "chip.visibility.link.unselected",
      "chip.visibility.link.selected",
      "chip.visibility.friends.unselected",
      "chip.visibility.friends.selected",
      "chip.visibility.public.unselected",
      "chip.visibility.public.selected",
      "who.enabled",
      "who.disabled"
    ],
    "seatPriority": [],
    "role": "Resolve base mode, radio choices, then WHO availability, then catalog disabled and busy/error/sound. WHO is live only for PUBLIC and keeps its selected value when unavailable."
  },
  "stateDataContract": {
    "fixturesOnly": [
      "values",
      "examples"
    ],
    "runtime": "Preserve existing date, players, lines/dateLines, pace, vibe and busy behavior. Add visibility (link/friends/public; default link) and who (open/women/men/mix; default open). WHO controls are enabled only when visibility is public; otherwise dim label and all four words, preserve geometry and selection. New UI values mirror Room Settings; API wiring belongs to implementation."
  },
  "layoutChangesFromReference": [
    "Added WHO CAN JOIN after VIBE: OPEN/WOMEN/MEN/MIX, widths182, gaps16/3.",
    "Added VISIBILITY next: LINK/FRIENDS/PUBLIC, reusing ROUNDS horizontal geometry.",
    "Added divider.who y1235 and divider.visibility y1395; retained all four original dividers.",
    "DATE MODE, HOW TO PLAY, CTA and busy text moved +320; form h788→1108; content height1672→1992.",
    "Updated only badge geometry from stale baseline76 to production61 at dx−66/dy−29, as specifically ordered.",
    "Historical unresolved A/B metadata replaced by explicit owner-selected26.",
    "Revision 4 only: HOW TO PLAY plate x258.956/y1552/w423.088/h104, tint cyan; info icon x322.272/y1578/50x50; label x378.272/y1586/w234/h40, cap1606, role button30; hit x258.956/y1546/w423.088/h116; removed howto.l1/l2; CTA y1724 and content1992 retained."
  ],
  "seatInteractionRules": {
    "source": "apps/client/src/screens/Create.tsx:89",
    "selection": "not applicable: no lobby seats on Create",
    "rules": []
  },
  "verification": {
    "status": "PASS for revision 4 layout checks; specified button30 and inherited chip26 retained; generic text floor not passed",
    "applicationCodeWritten": false,
    "newArtworkCount": 0,
    "published": false,
    "browserOrProductionTestsRun": false,
    "sourceLayoutSha256": "34b9a6d9bdb07915c390325df0b70753c07293cc3a0156b5917143cb5cb440e7",
    "font": {
      "path": "apps/client/public/fonts/Nunito-latin.woff2",
      "sha256": "ba344451eab25b217a165363b1982048a5e5830a0daf36577973955a04cac793",
      "method": "Actual local WOFF2, FreeType variable weights and HarfBuzz shaping, unhinted at4x; alpha128 glyph ink against first inward half-peak neon boundary for each occupied glyph row."
    },
    "sourceAssets": [
      {
        "id": "board9.png",
        "path": "apps/client/public/art/lobby-kit/board9.png",
        "width": 640,
        "height": 640,
        "sha256": "ff3a8f9078435101fdc3c4ce5d5ecdaa17e6de5999278710861bf503700665fb"
      },
      {
        "id": "row.divider.png",
        "path": "apps/client/public/art/lobby-kit/row.divider.png",
        "width": 800,
        "height": 24,
        "sha256": "2a1ea1caad9ff24d8de98d9374920456dee39b81f83bf78fbc1302f301848ba3"
      },
      {
        "id": "small.button.png",
        "path": "apps/client/public/art/lobby-kit/small.button.png",
        "width": 812,
        "height": 228,
        "sha256": "c0a274c1d527673a77055107fae0cbd3149ec8fbbe9fb2128129515ba86479ed"
      },
      {
        "id": "cta.plate.png",
        "path": "apps/client/public/art/lobby-kit/cta.plate.png",
        "width": 1736,
        "height": 326,
        "sha256": "ae9529479f4f35a908b8acd3f2e196be029ae229eb90d3b4dc969e7d8e7dcdde"
      },
      {
        "id": "sticker.ul.png",
        "path": "apps/client/public/art/lobby-kit/sticker.ul.png",
        "width": 328,
        "height": 308,
        "sha256": "54f64ea3c8e610d9681118192d797074b5f005d3f3b570cf75d4760c1678660d"
      },
      {
        "id": "sticker.ur.png",
        "path": "apps/client/public/art/lobby-kit/sticker.ur.png",
        "width": 396,
        "height": 308,
        "sha256": "0112673e6dbd9a38ab1c48d9a523973d6ccba02b38e3dd02cc6edd7728cd8f8e"
      },
      {
        "id": "apps/client/public/art/ui-head/bg@2x.png",
        "path": "apps/client/public/art/ui-head/bg@2x.png",
        "width": 276,
        "height": 276,
        "sha256": "ed70ede39d5d34e59c6619b7d84082814b69058bbd929b4ce0d895185220f820"
      },
      {
        "id": "apps/client/public/art/ui-head/icon-back@2x.png",
        "path": "apps/client/public/art/ui-head/icon-back@2x.png",
        "width": 276,
        "height": 276,
        "sha256": "026c480685d45fca3639e55537d5a3d3557f3ffb72cfbbf6e6e84354ad954694"
      },
      {
        "id": "apps/client/public/art/ui-head/icon-sound-on@2x.png",
        "path": "apps/client/public/art/ui-head/icon-sound-on@2x.png",
        "width": 276,
        "height": 276,
        "sha256": "4cbe7e8ec9c7d9ab1dc14c1046c12fe03684e9fc1853b3514e18acbc014671ff"
      },
      {
        "id": "apps/client/public/art/ui-head/icon-sound-off@2x.png",
        "path": "apps/client/public/art/ui-head/icon-sound-off@2x.png",
        "width": 276,
        "height": 276,
        "sha256": "25814b1deba5c0188b2840bb696bc15f34d5fbaeaf21f049790b4b13e2d0b249"
      },
      {
        "id": "create.icon.players",
        "path": "art/src/create-elements-2026-10-05/delivery/icon.players.png",
        "width": 82,
        "height": 63,
        "sha256": "219264a5130c4ee7f2eb30d3ec64a54450f2f093eadde8913e88eff808383a7b"
      },
      {
        "id": "create.icon.rounds",
        "path": "art/src/create-elements-2026-10-05/delivery/icon.rounds.png",
        "width": 76,
        "height": 79,
        "sha256": "187a8414eadd04e426374564632d8c7de54fb7a961d3a278c09f877e7f8de066"
      },
      {
        "id": "create.icon.pace",
        "path": "art/src/create-elements-2026-10-05/delivery/icon.pace.png",
        "width": 58,
        "height": 77,
        "sha256": "77954f485442336a23a785b925a819e3cf72d4c60a75e3864b58a3af280c9c90"
      },
      {
        "id": "create.icon.vibe",
        "path": "art/src/create-elements-2026-10-05/delivery/icon.vibe.png",
        "width": 77,
        "height": 73,
        "sha256": "84120d1f8654a0c4b7a8e754fd78da07d1e93192bb3aca5bc19ebb5b6f5b8f92"
      },
      {
        "id": "create.icon.date",
        "path": "art/src/create-elements-2026-10-05/delivery/icon.date.png",
        "width": 93,
        "height": 87,
        "sha256": "91735ea56c9514fe121cdcd8fa371eaed8c8e01eb44d986012ba229a87d2692f"
      },
      {
        "id": "create.howto.icon",
        "path": "art/src/create-elements-2026-10-05/delivery/howto.icon.png",
        "width": 153,
        "height": 154,
        "sha256": "af90d193dcc844c307ed758a9262648ad7a9f71d3c7089c126c84de7f9a979b6"
      },
      {
        "id": "create.date.switch.off",
        "path": "art/src/create-elements-2026-10-05/delivery/date.switch.off.png",
        "width": 219,
        "height": 129,
        "sha256": "c6ddda1bb3f13b7878943916929fb4c7d91842437348d294904d13245c903ff3"
      },
      {
        "id": "create.date.switch.on",
        "path": "art/src/create-elements-2026-10-05/delivery/date.switch.on.png",
        "width": 219,
        "height": 129,
        "sha256": "09bc900cbc044b5b6ad62c36132ddc0a3e7726f67652e5e0a74616a6ab43f40e"
      },
      {
        "id": "create.pill.off",
        "path": "art/src/create-elements-2026-10-05/delivery/slice/pill.off.png",
        "width": 247,
        "height": 140,
        "sha256": "4e4c0d8bfeb8c1fcaabb2a0cb9f02c3979a9a723a189da8df7ebaab469d32cb2"
      },
      {
        "id": "create.pill.on",
        "path": "art/src/create-elements-2026-10-05/delivery/slice/pill.on.png",
        "width": 247,
        "height": 140,
        "sha256": "fe020c119da9e66c9acf92c0da5a3d57bab8f6a617716ee20eb5a7d6dbcdc0b3"
      },
      {
        "id": "title",
        "path": "art/src/create-elements-2026-10-05/delivery2/title@2x.png",
        "width": 1180,
        "height": 248,
        "sha256": "53f6fcc7ae2539486125590ef88e9125402f32ccb90a3d910d719674cf7e41f4"
      },
      {
        "id": "cta.lettering",
        "path": "art/src/create-elements-2026-10-05/delivery2/cta.lettering@2x.png",
        "width": 1024,
        "height": 216,
        "sha256": "a003db25c7f27863e702cc4c257cdd30a6615d0abfdc87378133be8cea8b37fd"
      },
      {
        "id": "k18.badge",
        "path": "apps/client/public/art/create-kit/k18.badge.png",
        "width": 152,
        "height": 152,
        "sha256": "6ec66aa7bcc341c134a8e839faf3be9ced5f679b1c39c1c09193a115dc5ef50a"
      },
      {
        "id": "apps/client/public/art/lobby-bg/friends.png",
        "path": "apps/client/public/art/lobby-bg/friends.png",
        "width": 941,
        "height": 1672,
        "sha256": "5f0ba22c8354bedb837806daf9269877ef3a7c29edae44504588e08bfa2c4e3b"
      },
      {
        "id": "apps/client/public/art/room-logos/lobby-friends.png",
        "path": "apps/client/public/art/room-logos/lobby-friends.png",
        "width": 880,
        "height": 500,
        "sha256": "00944ff4a68a8ee16ccd9cd0d884e04e4095843dc2aea32cf8ca0f08cbda6f78"
      },
      {
        "id": "apps/client/public/art/lobby-kit/slogan.friends.l.png",
        "path": "apps/client/public/art/lobby-kit/slogan.friends.l.png",
        "width": 300,
        "height": 322,
        "sha256": "e969b9a216c5484ddae704bce7ef2909cc52b36f48b9af074e0aed3c8d747719"
      },
      {
        "id": "apps/client/public/art/lobby-kit/slogan.friends.r.png",
        "path": "apps/client/public/art/lobby-kit/slogan.friends.r.png",
        "width": 295,
        "height": 322,
        "sha256": "33d638f768c4226be646a6f239817e90ff2b479674568cd070c8f58a20c0f8ba"
      },
      {
        "id": "apps/client/public/art/lobby-bg/date.png",
        "path": "apps/client/public/art/lobby-bg/date.png",
        "width": 941,
        "height": 1672,
        "sha256": "fe7bbf5f7f68ad52be2de726a308872fdeb1efb544e5998ae9795f03d91db854"
      },
      {
        "id": "apps/client/public/art/room-logos/lobby-date.png",
        "path": "apps/client/public/art/room-logos/lobby-date.png",
        "width": 880,
        "height": 521,
        "sha256": "b694f0f1acceccfd6531128c0e57318b9d3d3d98180e4adef5dad33ae38debbd"
      },
      {
        "id": "apps/client/public/art/lobby-kit/slogan.date.l.png",
        "path": "apps/client/public/art/lobby-kit/slogan.date.l.png",
        "width": 342,
        "height": 281,
        "sha256": "04ffccb13e2789eac8e479fa762c99d0b5c8b711f7a3eaef5f7b295ac7900009"
      },
      {
        "id": "apps/client/public/art/lobby-kit/slogan.date.r.png",
        "path": "apps/client/public/art/lobby-kit/slogan.date.r.png",
        "width": 348,
        "height": 309,
        "sha256": "bc0661fbe9b009463e76d3c01993583da2c026f2b14ea6de49ceae846b74eca8"
      },
      {
        "id": "icon.info.png",
        "path": "art/src/lobby-elements-2026-09-22/icon.info.png",
        "width": 640,
        "height": 640,
        "sha256": "01566712c254793cf47ab8b4c65ffa650289a9b20c26c4a15ff8da9a1b5165e0"
      }
    ],
    "wordFit": {
      "status": "PASS",
      "minimumRequired": 16,
      "minimumActual": 16.423549,
      "checks": [
        {
          "id": "chip.p3.label",
          "text": "3",
          "size": 26,
          "weight": 700,
          "advance": 15.601563,
          "controlWidth": 182,
          "imageWidth": 206,
          "lane": 132,
          "states": {
            "on": {
              "left": 76.699219,
              "right": 75.87221
            },
            "off": {
              "left": 76.699219,
              "right": 76.086496
            }
          },
          "pass": true
        },
        {
          "id": "chip.p4.label",
          "text": "4",
          "size": 26,
          "weight": 700,
          "advance": 15.601563,
          "controlWidth": 182,
          "imageWidth": 206,
          "lane": 132,
          "states": {
            "on": {
              "left": 77.62779,
              "right": 74.836496
            },
            "off": {
              "left": 76.913504,
              "right": 74.836496
            }
          },
          "pass": true
        },
        {
          "id": "chip.p5.label",
          "text": "5",
          "size": 26,
          "weight": 700,
          "advance": 15.601563,
          "controlWidth": 182,
          "imageWidth": 206,
          "lane": 132,
          "states": {
            "on": {
              "left": 77.234933,
              "right": 74.907924
            },
            "off": {
              "left": 77.199219,
              "right": 75.586496
            }
          },
          "pass": true
        },
        {
          "id": "chip.p6.label",
          "text": "6",
          "size": 26,
          "weight": 700,
          "advance": 15.601563,
          "controlWidth": 182,
          "imageWidth": 206,
          "lane": 132,
          "states": {
            "on": {
              "left": 77.413504,
              "right": 74.87221
            },
            "off": {
              "left": 77.413504,
              "right": 75.37221
            }
          },
          "pass": true
        },
        {
          "id": "chip.r1.label",
          "text": "1",
          "size": 26,
          "weight": 700,
          "advance": 15.601563,
          "controlWidth": 242,
          "imageWidth": 266,
          "lane": 192,
          "states": {
            "on": {
              "left": 108.663504,
              "right": 105.12221
            },
            "off": {
              "left": 107.949219,
              "right": 105.12221
            }
          },
          "pass": true
        },
        {
          "id": "chip.r2.label",
          "text": "2",
          "size": 26,
          "weight": 700,
          "advance": 15.601563,
          "controlWidth": 244,
          "imageWidth": 268,
          "lane": 194,
          "states": {
            "on": {
              "left": 107.699219,
              "right": 105.87221
            },
            "off": {
              "left": 107.699219,
              "right": 105.87221
            }
          },
          "pass": true
        },
        {
          "id": "chip.r3.label",
          "text": "3",
          "size": 26,
          "weight": 700,
          "advance": 15.601563,
          "controlWidth": 244,
          "imageWidth": 268,
          "lane": 194,
          "states": {
            "on": {
              "left": 107.699219,
              "right": 106.87221
            },
            "off": {
              "left": 107.699219,
              "right": 107.086496
            }
          },
          "pass": true
        },
        {
          "id": "chip.chill.label",
          "text": "CHILL",
          "size": 26,
          "weight": 700,
          "advance": 74.335938,
          "controlWidth": 366,
          "imageWidth": 390,
          "lane": 316,
          "states": {
            "on": {
              "left": 140.046317,
              "right": 136.739397
            },
            "off": {
              "left": 140.046317,
              "right": 136.739397
            }
          },
          "pass": true
        },
        {
          "id": "chip.quick.label",
          "text": "QUICK",
          "size": 26,
          "weight": 700,
          "advance": 81.898438,
          "controlWidth": 368,
          "imageWidth": 392,
          "lane": 318,
          "states": {
            "on": {
              "left": 137.265067,
              "right": 134.306362
            },
            "off": {
              "left": 137.265067,
              "right": 134.770647
            }
          },
          "pass": true
        },
        {
          "id": "chip.v1.label",
          "text": "FRIENDLY",
          "size": 26,
          "weight": 700,
          "advance": 122.179688,
          "controlWidth": 181.5,
          "imageWidth": 205.5,
          "lane": 131.5,
          "states": {
            "on": {
              "left": 23.660156,
              "right": 20.196987
            },
            "off": {
              "left": 23.660156,
              "right": 20.911272
            }
          },
          "pass": true
        },
        {
          "id": "chip.v2.label",
          "text": "BOLDER",
          "size": 26,
          "weight": 700,
          "advance": 106.082031,
          "controlWidth": 181.5,
          "imageWidth": 205.5,
          "lane": 131.5,
          "states": {
            "on": {
              "left": 31.708984,
              "right": 29.612444
            },
            "off": {
              "left": 31.708984,
              "right": 29.612444
            }
          },
          "pass": true
        },
        {
          "id": "chip.v3.label",
          "text": "FLIRTY",
          "size": 26,
          "weight": 700,
          "advance": 86.421875,
          "controlWidth": 181.5,
          "imageWidth": 205.5,
          "lane": 131.5,
          "states": {
            "on": {
              "left": 41.539063,
              "right": 38.06808
            },
            "off": {
              "left": 41.539063,
              "right": 38.782366
            }
          },
          "pass": true
        },
        {
          "id": "chip.v4.label",
          "text": "NAUGHTY",
          "size": 26,
          "weight": 700,
          "advance": 129.632813,
          "controlWidth": 181.5,
          "imageWidth": 205.5,
          "lane": 131.5,
          "states": {
            "on": {
              "left": 19.719308,
              "right": 16.423549
            },
            "off": {
              "left": 19.933594,
              "right": 17.137835
            }
          },
          "pass": true
        },
        {
          "id": "chip.pair.label",
          "text": "2",
          "size": 26,
          "weight": 700,
          "advance": 15.601563,
          "controlWidth": 244,
          "imageWidth": 268,
          "lane": 194,
          "states": {
            "on": {
              "left": 107.699219,
              "right": 105.87221
            },
            "off": {
              "left": 107.699219,
              "right": 105.87221
            }
          },
          "pass": true
        },
        {
          "id": "chip.who.open.label",
          "text": "OPEN",
          "size": 26,
          "weight": 700,
          "advance": 72.335938,
          "controlWidth": 182,
          "imageWidth": 206,
          "lane": 132,
          "states": {
            "on": {
              "left": 49.046317,
              "right": 46.525112
            },
            "off": {
              "left": 49.046317,
              "right": 47.239397
            }
          },
          "pass": true
        },
        {
          "id": "chip.who.women.label",
          "text": "WOMEN",
          "size": 26,
          "weight": 700,
          "advance": 106.417969,
          "controlWidth": 182,
          "imageWidth": 206,
          "lane": 132,
          "states": {
            "on": {
              "left": 30.57673,
              "right": 29.566127
            },
            "off": {
              "left": 30.791016,
              "right": 30.280413
            }
          },
          "pass": true
        },
        {
          "id": "chip.who.men.label",
          "text": "MEN",
          "size": 26,
          "weight": 700,
          "advance": 57.539063,
          "controlWidth": 182,
          "imageWidth": 206,
          "lane": 132,
          "states": {
            "on": {
              "left": 56.016183,
              "right": 54.126674
            },
            "off": {
              "left": 56.230469,
              "right": 54.84096
            }
          },
          "pass": true
        },
        {
          "id": "chip.who.mix.label",
          "text": "MIX",
          "size": 26,
          "weight": 700,
          "advance": 47.371094,
          "controlWidth": 182,
          "imageWidth": 206,
          "lane": 132,
          "states": {
            "on": {
              "left": 61.100167,
              "right": 58.29269
            },
            "off": {
              "left": 61.314453,
              "right": 58.756975
            }
          },
          "pass": true
        },
        {
          "id": "chip.visibility.link.label",
          "text": "LINK",
          "size": 26,
          "weight": 700,
          "advance": 58.683594,
          "controlWidth": 242,
          "imageWidth": 266,
          "lane": 192,
          "states": {
            "on": {
              "left": 85.443917,
              "right": 82.69894
            },
            "off": {
              "left": 85.658203,
              "right": 83.163225
            }
          },
          "pass": true
        },
        {
          "id": "chip.visibility.friends.label",
          "text": "FRIENDS",
          "size": 26,
          "weight": 700,
          "advance": 110.972656,
          "controlWidth": 244,
          "imageWidth": 268,
          "lane": 194,
          "states": {
            "on": {
              "left": 60.513672,
              "right": 58.772042
            },
            "off": {
              "left": 60.513672,
              "right": 58.772042
            }
          },
          "pass": true
        },
        {
          "id": "chip.visibility.public.label",
          "text": "PUBLIC",
          "size": 26,
          "weight": 700,
          "advance": 93.652344,
          "controlWidth": 244,
          "imageWidth": 268,
          "lane": 194,
          "states": {
            "on": {
              "left": 69.173828,
              "right": 66.8976
            },
            "off": {
              "left": 69.173828,
              "right": 67.1476
            }
          },
          "pass": true
        },
        {
          "id": "chip.v1.label",
          "text": "DATING",
          "size": 26,
          "weight": 700,
          "advance": 98.800781,
          "controlWidth": 181.5,
          "imageWidth": 205.5,
          "lane": 131.5,
          "states": {
            "on": {
              "left": 35.349609,
              "right": 33.721819
            },
            "off": {
              "left": 35.349609,
              "right": 33.721819
            }
          },
          "pass": true
        }
      ],
      "disabled": "Word color changes only; selected/unselected surfaces and geometry covered."
    },
    "hitTargets": {
      "status": "PASS",
      "minimumHeight": 116,
      "minimumCssHeight360": 44.378320935175346,
      "states": [
        {
          "state": "friends",
          "count": 25,
          "overlaps": []
        },
        {
          "state": "date",
          "count": 22,
          "overlaps": []
        },
        {
          "state": "empty",
          "count": 25,
          "overlaps": []
        },
        {
          "state": "invalid",
          "count": 25,
          "overlaps": []
        },
        {
          "state": "disabled",
          "count": 25,
          "overlaps": []
        },
        {
          "state": "friends_public",
          "count": 25,
          "overlaps": []
        }
      ],
      "scope": "All visible target boxes including disabled choices; mutually exclusive Friends/Date players checked separately. Decorative badges and dividers are not targets."
    },
    "inkOverlaps": {
      "status": "PASS",
      "states": [
        {
          "state": "friends",
          "wordCollisions": [],
          "badgeCollisions": []
        },
        {
          "state": "date",
          "wordCollisions": [],
          "badgeCollisions": []
        },
        {
          "state": "empty",
          "wordCollisions": [],
          "badgeCollisions": []
        },
        {
          "state": "invalid",
          "wordCollisions": [],
          "badgeCollisions": []
        },
        {
          "state": "disabled",
          "wordCollisions": [],
          "badgeCollisions": []
        },
        {
          "state": "friends_public",
          "wordCollisions": [],
          "badgeCollisions": []
        }
      ],
      "scope": "Live text ink boxes pairwise and against both badge canvases. Decorative image canvases, glow padding, board containment and each button with its own label intentionally overlap."
    },
    "dividers": {
      "status": "PASS",
      "rows": [
        "PLAYERS",
        "ROUNDS",
        "PACE",
        "VIBE",
        "WHO CAN JOIN",
        "VISIBILITY",
        "DATE MODE"
      ],
      "instances": [
        {
          "id": "divider.players",
          "x": 108,
          "y": 597,
          "w": 726,
          "h": 12
        },
        {
          "id": "divider.rounds",
          "x": 108,
          "y": 757,
          "w": 726,
          "h": 12
        },
        {
          "id": "divider.pace",
          "x": 108,
          "y": 917,
          "w": 726,
          "h": 12
        },
        {
          "id": "divider.vibe",
          "x": 108,
          "y": 1075,
          "w": 726,
          "h": 12
        },
        {
          "id": "divider.who",
          "x": 108,
          "y": 1235,
          "w": 726,
          "h": 12
        },
        {
          "id": "divider.visibility",
          "x": 108,
          "y": 1395,
          "w": 726,
          "h": 12
        }
      ],
      "count": 6
    },
    "badges": {
      "status": "PASS",
      "size": 61,
      "dx": -66,
      "dy": -29,
      "instances": [
        {
          "id": "k18.badge.bolder",
          "parent": "chip.v2",
          "x": 417,
          "y": 947,
          "w": 61,
          "h": 61
        },
        {
          "id": "k18.badge.naughty",
          "parent": "chip.v4",
          "x": 792,
          "y": 947,
          "w": 61,
          "h": 61
        }
      ],
      "unfiltered": true
    },
    "page": {
      "status": "PASS",
      "width": 941,
      "height": 1992,
      "scaleBase": {
        "w": 941,
        "h": 1672
      },
      "addedHeight": 320,
      "formBottom": 1536,
      "howtoTop": 1552,
      "ctaBottom": 1868,
      "bottomTail": 124
    },
    "textSizeAt360": {
      "chip": 9.946865037194474,
      "label": 12.242295430393199,
      "note": "Fixed26 is explicit owner instruction in current brief. Historical generic16 CSS px floor is not claimed to pass.",
      "howto": 11.477151965993624,
      "howtoMeets16CssPx": false
    },
    "stateCoverage": {
      "filled": true,
      "publicEnabled": true,
      "linkDisabled": true,
      "friendsDisabled": true,
      "empty": true,
      "invalid": true,
      "disabled": true,
      "busy": true,
      "errorRetainsSelections": true,
      "date": true,
      "soundOff": true,
      "geometryInvariant": true,
      "validReferences": 580
    },
    "previews": [
      {
        "path": "art/src/create-elements-2026-10-05/preview4/LAYOUT-create-4.png",
        "width": 941,
        "height": 1992,
        "sha256": "8211eaf86ff1410121cc0ddc7b2741d9afd6962d192850020a0e6c02231fe3b2"
      },
      {
        "path": "art/src/create-elements-2026-10-05/preview4/LAYOUT-create-4-360.png",
        "width": 360,
        "height": 762,
        "sha256": "d039dced0518198f42a7fffc3ef91abfb87fb4dc824ff10e4bd6c1dc72a8377d"
      }
    ],
    "originalFilesUnchanged": {
      "count": 125,
      "changed": []
    },
    "howto": {
      "status": "PASS",
      "plate": {
        "x": 258.956,
        "y": 1552,
        "w": 423.088,
        "h": 104,
        "tint": "cyan"
      },
      "sourceSlices": {
        "left": 229,
        "right": 229
      },
      "renderedCap": 104.45614035087719,
      "icon": {
        "x": 322.27200000000005,
        "y": 1578,
        "w": 50,
        "h": 50,
        "sourceFilter": "brightness(0) invert(1)"
      },
      "label": {
        "x": 378.27200000000005,
        "y": 1586,
        "w": 234,
        "h": 40,
        "capCenterY": 1606,
        "role": "button",
        "size": 30,
        "weight": 800,
        "advance": 214.96875,
        "laneFits": true
      },
      "hit": {
        "id": "howto",
        "x": 258.956,
        "y": 1546,
        "w": 423.088,
        "h": 116,
        "action": "how-to-play",
        "ariaLabel": "How to play",
        "enabled": true
      },
      "removedTextIds": [
        "howto.title",
        "howto.l1",
        "howto.l2"
      ],
      "gaps": {
        "formToPlate": 16,
        "plateToCta": 68
      },
      "unchangedEntries": 102,
      "otherStateAndPageDataUnchanged": true,
      "previewPixelComparison": {
        "reference": "art/src/create-elements-2026-10-05/preview3/LAYOUT-create-3.png",
        "bandY": [
          1550,
          1722
        ],
        "changedPixelsOutsideBand": 0,
        "changedPixelsInsideBand": 125469
      }
    }
  },
  "dateReference": "art/src/create-elements-2026-10-05/NOW-create-date.png",
  "reviewStatus": "Revision 4 design delivery per BRIEF-create-4.md; lobby HOW TO PLAY reused; all other revision 3 layout and states retained. Implementation and publication not performed.",
  "typographyReview": {
    "selectedOption": "A",
    "recommendedOption": "A",
    "basePreviewOption": "A",
    "status": "26 is explicitly fixed by BRIEF-create-3.md; no pending A/B decision.",
    "common": {
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "minimumSidePaddingFromInnerEdge": 16,
      "innerEdgeSafetyInsetFromControl": 9,
      "controlPadding": 25,
      "alignment": "centred advance in equal padded lanes; short labels naturally leave more space than long labels; no tracking, scaling, wrapping or ellipsis"
    },
    "A": {
      "size": 26,
      "lineHeight": 33,
      "contentHeight": 1992,
      "stageScaleBase": {
        "w": 941,
        "h": 1672
      },
      "elementOverrides": {},
      "textOverrides": {},
      "hitOverrides": {},
      "cssPxAt360": 9.946865037194474,
      "meetsTextFloor": false
    }
  },
  "badgeContract": {
    "stageDiameter": 61,
    "anchor": "pill artwork box upper right; offsets point to badge canvas upper left",
    "dx": -66,
    "dy": -29,
    "instances": [
      {
        "id": "k18.badge.bolder",
        "parent": "chip.v2",
        "x": 417,
        "y": 947,
        "w": 61,
        "h": 61
      },
      {
        "id": "k18.badge.naughty",
        "parent": "chip.v4",
        "x": 792,
        "y": 947,
        "w": 61,
        "h": 61
      }
    ],
    "states": {
      "selected": {
        "opacity": 1,
        "filter": "none"
      },
      "unselected": {
        "opacity": 1,
        "filter": "none"
      },
      "disabled": {
        "opacity": 1,
        "filter": "none"
      },
      "empty": {
        "opacity": 1,
        "filter": "none"
      },
      "error": {
        "opacity": 1,
        "filter": "none"
      }
    },
    "hitBoxEquivalent": {
      "dx": -54,
      "dy": -21,
      "explanation": "Pill image right is hit right +12; pill image top is hit top +8."
    }
  },
  "contentHeight": 1992,
  "stageScaleBase": {
    "w": 941,
    "h": 1672
  },
  "scroll": {
    "type": "form",
    "axis": "y",
    "contentHeight": 1992,
    "viewportBaseHeight": 1672,
    "overflowAtBase": 320,
    "onlyIfNeeded": true,
    "stickyElements": [],
    "scene": "Existing image stays at 0,0,941,1672; below it the existing --navy-900 #070a1f canvas is visible. No resizing, cover crop, duplication or new background."
  }
}
